function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M362.43,233.59s-5.18-21.41-5.68-24.07c-.63-3.35,5.31-34,3.47-35.26-3-2-24.84,21.74-28.4,26.43-2.72,3.58-10,28.62-10,28.62Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M322.12,227.48a1.14,1.14,0,1,0-2.11-.86,1.14,1.14,0,1,0,2.11.86Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M360.82,233.49a1.14,1.14,0,1,0-1.48.63A1.15,1.15,0,0,0,360.82,233.49Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M322.16,223.49a1,1,0,1,0-.47,1.31A1,1,0,0,0,322.16,223.49Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M347.52,186a1,1,0,1,0-.48,1.31A1,1,0,0,0,347.52,186Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M319.42,225a.83.83,0,1,0-.4,1.11A.83.83,0,0,0,319.42,225Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M349.82,183a.83.83,0,0,0-1.11-.4.84.84,0,0,0-.4,1.11.83.83,0,0,0,1.51-.71Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M346.21,211.84a.84.84,0,1,0-.4,1.11A.84.84,0,0,0,346.21,211.84Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M356.77,223.13a.42.42,0,0,0-.56-.2.41.41,0,0,0-.2.55.42.42,0,0,0,.76-.35Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M328.67,218.42a.41.41,0,1,0-.2.55A.41.41,0,0,0,328.67,218.42Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M353.39,185.38a.41.41,0,0,0-.55-.2.42.42,0,0,0-.2.56.41.41,0,0,0,.55.2A.42.42,0,0,0,353.39,185.38Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M282.49,233.25s-18.64,10.27-20.86,11.65c-2.8,1.73-20.8,26-22.89,25.46-3.39-.81-.69-31.89.33-37.49.78-4.27,13.89-25.8,13.89-25.8Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M251.85,208.5a1.1,1.1,0,0,1-2-.95,1.1,1.1,0,1,1,2,.95Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M281.37,232.17a1.1,1.1,0,0,1-1.47.52,1.1,1.1,0,0,1,1-2A1.11,1.11,0,0,1,281.37,232.17Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M249,211.13a1,1,0,0,1-1.2-.63,1,1,0,0,1,.63-1.19.94.94,0,0,1,1.19.62A1,1,0,0,1,249,211.13Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M238.85,253.63a1,1,0,0,1-1.19-.63,1,1,0,1,1,1.82-.56A.94.94,0,0,1,238.85,253.63Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M248.31,208.21a.81.81,0,0,1-1-.54.8.8,0,0,1,.53-1,.81.81,0,0,1,1,.53A.82.82,0,0,1,248.31,208.21Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M238.21,257.25a.81.81,0,1,1,.53-1A.82.82,0,0,1,238.21,257.25Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M256.41,235.87a.81.81,0,1,1,.53-1A.82.82,0,0,1,256.41,235.87Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M271.34,236a.41.41,0,0,1-.24-.78.41.41,0,0,1,.24.78Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M249.66,219.07a.39.39,0,0,1-.5-.26.41.41,0,0,1,.26-.51.42.42,0,0,1,.51.27A.39.39,0,0,1,249.66,219.07Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M242.23,258.24a.4.4,0,1,1-.24-.77.4.4,0,0,1,.24.77Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M467.11,281.46s15.77-12.67,17.78-14.15c2.55-1.87,31.14-11.38,31.36-13.11.36-2.82-29.55-6.63-35.12-6.89-4.24-.2-28.69,6-28.69,6Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M454.14,252.69a1.05,1.05,0,0,0,1-1.05,1,1,0,0,0-1.2-.69,1,1,0,0,0-1,1.05A1,1,0,0,0,454.14,252.69Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M466.48,280.37a1.06,1.06,0,0,0,1-1.05,1,1,0,0,0-1.2-.69,1.05,1.05,0,0,0-1,1.06A1,1,0,0,0,466.48,280.37Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M457.52,251a.64.64,0,0,0-.19-1,1.14,1.14,0,0,0-1.32.26.66.66,0,0,0,.19,1.06A1.14,1.14,0,0,0,457.52,251Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M500.59,251.09a.65.65,0,0,0-.19-1.05,1.12,1.12,0,0,0-1.32.27.65.65,0,0,0,.19,1.05A1.12,1.12,0,0,0,500.59,251.09Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M455,249.85a.55.55,0,0,0-.16-.89,1,1,0,0,0-1.12.22.56.56,0,0,0,.16.9A1,1,0,0,0,455,249.85Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M504.18,251.27a.55.55,0,0,0-.16-.89,1,1,0,0,0-1.12.23.56.56,0,0,0,.16.89A1,1,0,0,0,504.18,251.27Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M478.19,261.48a.55.55,0,0,0-.16-.89,1,1,0,0,0-1.12.22.56.56,0,0,0,.16.9A1,1,0,0,0,478.19,261.48Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M473.4,273.24a.27.27,0,0,0-.08-.45.5.5,0,0,0-.56.11.28.28,0,0,0,.08.45A.49.49,0,0,0,473.4,273.24Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M464.74,253a.28.28,0,0,0-.08-.45.49.49,0,0,0-.56.11.28.28,0,0,0,.08.45A.49.49,0,0,0,464.74,253Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M503.78,254.62a.28.28,0,0,0-.08-.45.49.49,0,0,0-.56.11.28.28,0,0,0,.08.45A.49.49,0,0,0,503.78,254.62Z"
});

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.91,66.58,81,66.3l6.66-.11c2.23,0,4.47,0,6.7,0h.44v.45l.06,11.19v.5h-.5l-13.24-.06c-4.41,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.08-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.83-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45C92.21,67,90,67,87.84,67l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.68,52.47l13.13-.28,6.66-.11c2.22,0,4.46,0,6.69,0h.44v.45l0,11.19v.5h-.5L95.92,64.1c-4.41,0-8.83-.11-13.24-.16H82.4v-.27c0-1.9.08-3.78.13-5.65Zm0,0,.14,5.66c.05,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.83-.16,13.24-.16l13.24-.07-.5.5.06-11.19.44.45c-2.18,0-4.36,0-6.54-.06L96,52.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.39,115.45l13.13-.28,6.66-.11c2.22,0,4.46,0,6.69-.06h.45v.45l0,11.19v.5h-.5l-13.24-.07c-4.41,0-8.82-.11-13.24-.16h-.27v-.27c0-1.9.09-3.79.13-5.66Zm0,0,.14,5.65c.05,1.86.12,3.71.14,5.54l-.28-.28c4.42,0,8.83-.15,13.24-.16l13.24-.06-.5.5.06-11.19.44.44c-2.18,0-4.36,0-6.54,0l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.16,101.34l13.13-.28L545,101c2.23,0,4.46,0,6.69-.06h.45v.45l0,11.19v.5h-.51L538.4,113c-4.41,0-8.82-.11-13.24-.16h-.27v-.27c0-1.9.09-3.79.13-5.66Zm0,0,.15,5.65c0,1.86.11,3.71.13,5.54l-.28-.28c4.42,0,8.83-.15,13.24-.16l13.24-.06-.49.5.05-11.19.44.44c-2.18,0-4.35,0-6.54,0l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,52.47l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7,0h.44v.45l.06,11.19v.5h-.5L66.38,64.1c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.78.13-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16l13.24-.07-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.14,141.21l-13.12.28-6.67.11c-2.22.05-4.46,0-6.69.05h-.44v-.45L246.16,130v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28V130c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.83.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.09,248.5l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.86,262.61l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44l-.06-11.19v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.62,262.61l-13.13.27-6.66.12c-2.23,0-4.46,0-6.69.05h-.45v-.44l0-11.19v-.51h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.89-.09,3.78-.13,5.65Zm0,0L94.47,257c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.24.06.49-.49,0,11.19-.44-.45c2.18,0,4.35,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.5,52.47l13.12-.28,6.66-.11c2.23,0,4.47,0,6.7,0h.44v.45l.06,11.19v.5H682l-13.24-.06c-4.42,0-8.83-.11-13.24-.16h-.28v-.27c0-1.9.09-3.78.14-5.65Zm0,0,.14,5.66c0,1.86.11,3.7.13,5.53l-.27-.27c4.41,0,8.82-.16,13.24-.16L682,63.16l-.5.5,0-11.19.45.45c-2.18,0-4.36,0-6.55-.06l-6.58-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "628.93 216.81 662.49 216.81 681.7 121.05 650.97 106.93 628.93 216.81",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.88 216.81 628.93 216.81 650.97 106.93 554.91 106.93 532.88 216.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.16,
    y: 165.43,
    width: 51.43,
    height: 105.53,
    transform: "translate(1343.75 436.39) rotate(180)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.19 270.96 522.24 270.96 543.18 165.43 508.19 165.43 508.19 270.96",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.9,
    y: 165.43,
    width: 28.26,
    height: 105.53,
    transform: "translate(1264.06 436.39) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.93,
    y: 165.43,
    width: 28.26,
    height: 105.53,
    transform: "translate(988.12 436.39) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.19,
    y: 216.8,
    width: 109.71,
    height: 54.15,
    transform: "translate(1126.09 487.76) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.19,
    y: 193.39,
    width: 109.71,
    height: 23.63,
    transform: "translate(1126.09 410.42) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.23,165.43l-10.66-.19-10.67-.13h-.32v.33l-.11,12.35-.05,12.35c0,8.23-.06,16.47,0,24.7s0,16.47.14,24.7.18,16.46.36,24.7q.26-12.36.36-24.7c.1-8.23.11-16.47.14-24.7s0-16.47,0-24.7l0-12.35-.12-12.35-.32.32,10.67-.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.19,165.43c-.22,8.26-.32,16.53-.41,24.79L507.66,215l.12,24.79.15,12.4.26,12.39.26-12.39.15-12.4.12-24.79-.12-24.79C508.51,182,508.41,173.69,508.19,165.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.19,216.8c9.14.22,18.29.33,27.43.41l27.43.13,27.42-.13,13.72-.14,13.71-.27-13.71-.26-13.72-.15-27.42-.12-27.43.13C526.48,216.48,517.33,216.59,508.19,216.8Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.19,193.39c9.14.22,18.29.33,27.43.41l27.43.13,27.42-.13,13.72-.15,13.71-.26-13.71-.26L590.47,193l-27.42-.12-27.43.13C526.48,193.07,517.33,193.17,508.19,193.39Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "678.04 270.96 678.74 279.51 680.36 299.26 687.81 299.26 689.43 279.51 690.13 270.96 678.04 270.96",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "690.13 270.96 678.04 270.96 678.74 279.51 689.43 279.51 690.13 270.96",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "625.99 270.96 626.68 279.51 628.3 299.26 635.75 299.26 637.38 279.51 638.07 270.96 625.99 270.96",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "638.07 270.96 625.99 270.96 626.68 279.51 637.38 279.51 638.07 270.96",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "539.64 270.96 540.33 279.51 541.96 299.26 549.4 299.26 551.03 279.51 551.72 270.96 539.64 270.96",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.72 270.96 539.64 270.96 540.33 279.51 551.03 279.51 551.72 270.96",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.56 270.96 488.26 279.51 489.88 299.26 497.33 299.26 498.96 279.51 499.65 270.96 487.56 270.96",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.56 270.96 488.26 279.51 498.96 279.51 499.65 270.96 487.56 270.96",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.48,
    width: 0.86,
    height: 81.64,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.39 115.85 369.54 122.12 304.27 122.12 301.43 115.85 329.21 96.61 344.61 96.61 372.39 115.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.53 78.08 344.61 96.61 329.21 96.61 327.28 78.08 346.53 78.08",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.39 115.85 369.53 122.12 304.27 122.12 301.42 115.85 372.39 115.85",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.67,
    width: 0.86,
    height: 61.4,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.58 95.61 445.72 101.88 380.46 101.88 377.61 95.61 405.4 76.38 420.79 76.38 448.58 95.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.72 57.85 420.79 76.38 405.4 76.38 403.47 57.85 422.72 57.85",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "448.57 95.61 445.72 101.88 380.45 101.88 377.61 95.61 448.57 95.61",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.62,
    y: 97.32,
    width: 171.65,
    height: 7.37,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.58 133.7 69.89 133.7 67.21 104.69 76.58 104.69 76.58 133.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.31 133.7 205 133.7 207.68 104.69 198.31 104.69 198.31 133.7",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.21 104.69 76.57 104.69 76.57 114.68 68.13 114.68 67.21 104.69",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.68 104.69 206.76 114.68 198.31 114.68 198.31 104.69 207.68 104.69",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.78,53.1c-7.62,10.32-15.56,22.29-17.5,35.23,0,.19.3.26.34.06A75.94,75.94,0,0,1,100,78c5-1.37,9.92-2.51,12.55-7.48s2.34-11.77,1.83-17.33C114.34,52.92,113.93,52.9,113.78,53.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.06,77.94a85.76,85.76,0,0,1,13.4-21.71s.1,0,.06.07a91.74,91.74,0,0,0-9.14,14.37c2.52-2.56,5.28-4.85,7.67-7.57,0-.05.12,0,.08.08-2.37,2.85-5,5.94-8,8.05q-1.24,2.3-2.52,4.59l.64-.32a0,0,0,0,1,0,.06c-.23.11-.47.24-.71.34l-1.21,2.18C100.22,78.24,100,78.1,100.06,77.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.61,75.26a44.81,44.81,0,0,0,5.85-3.91.05.05,0,0,1,.07.08,31.31,31.31,0,0,1-5.84,4A.08.08,0,0,1,102.61,75.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.45,88.21c0,.15.28.15.28,0,0-4.26,0-8.54.07-12.81,1.09-2.21,3.43-3.43,5.06-5.19a22.82,22.82,0,0,0,3-4.23,30.51,30.51,0,0,0,3.52-11.75c.45-4.56-1.28-19.6-3.2-19.07-1,.27-4.22,7.71-5.07,10.18a70.33,70.33,0,0,0-3,12.48C94.56,67.82,94.69,78.12,95.45,88.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.42,69.83l0,0A96.66,96.66,0,0,1,98,53.75c1.23-5.63,2.66-10.93,5.56-16,0-.09.19,0,.14.09a59.22,59.22,0,0,0-4.46,12.25c.19-.31.43-.6.63-.88.08-.11.27,0,.19.11a7.62,7.62,0,0,1-.91,1.28h0c-1,4-1.72,8.15-2.33,12.25l.14-.15s.08,0,.06,0-.16.28-.25.41q-.45,3.14-.88,6.23a29.32,29.32,0,0,0,8.67-11.52s0,0,0,0a24,24,0,0,1-8.77,11.93c-.07.55-.15,1.11-.23,1.66,0,.12-.2.09-.2,0,0-.49,0-1,0-1.47A.12.12,0,0,1,95.42,69.83Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.17,62a85,85,0,0,0,7.56-13c0-.05.11,0,.09,0a42,42,0,0,1-7.51,13.1A.09.09,0,0,1,97.17,62Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,48c1.17-2.08,2.41-4.1,3.52-6.22,0-.06.11,0,.09.05a32.62,32.62,0,0,1-3.43,6.27C101,48.16,100.87,48.07,100.94,48Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.48,48.85s0,0,0,0S100.46,48.85,100.48,48.85Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.37,77.29a43.71,43.71,0,0,1-1,8.39c0,.31.09.61.13.92A39.66,39.66,0,0,0,94,77.25.3.3,0,0,0,94,77h0a62,62,0,0,0-.94-12.68c-1.32-7.83-4.2-15.34-9.66-21.21a.4.4,0,0,0-.61.13c-2.2,5.6-1.43,12.28.44,17.87a33,33,0,0,0,4.33,8.49C89.46,72.19,91.85,74.41,93.37,77.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.06,45.68C89.24,54.08,92.84,64,93.28,74c0,.18-.29.22-.32,0-.12-.89-.25-1.77-.4-2.65h0a34.48,34.48,0,0,1-5.87-6.78s0-.1.08-.06a71.33,71.33,0,0,0,5.7,6.21q-.55-3.28-1.33-6.48l-.41-.48c-.09-.11.06-.26.15-.15l.13.13a75.75,75.75,0,0,0-2.71-8.59,26.39,26.39,0,0,1-3.75-4.82,0,0,0,0,1,.07,0c.77,1.08,1.52,2.17,2.39,3.18.35.4.74.77,1.1,1.16a66.67,66.67,0,0,0-4.24-8.83A.12.12,0,0,1,84.06,45.68Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.11,56c1.67,2.26,3.58,4.4,5.13,6.73.05.07,0,.13-.11.08A34.14,34.14,0,0,1,85,56.11C85,56,85.06,56,85.11,56Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.48,63.29l.07.07s0,.13-.08.08l-.07-.07C90.35,63.32,90.43,63.24,90.48,63.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.15,59.71a25.75,25.75,0,0,0,5.47,12.81A13.41,13.41,0,0,0,85,76C87,76.92,89,78,91,78.79a39,39,0,0,1,2.1,7.44c.06-.22.12-.45.19-.66C92,74.63,84.88,65.28,75.83,59.28A.44.44,0,0,0,75.15,59.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.28,62.94c-.06-.06,0-.17.1-.12A37,37,0,0,1,89.91,77c.07.15-.14.28-.22.13-.42-.74-.85-1.45-1.29-2.16h0a12.42,12.42,0,0,1-5.56-3.22,0,0,0,1,1,.06-.06,12.77,12.77,0,0,0,2.61,1.83,28.16,28.16,0,0,0,2.63,1c-.77-1.21-1.56-2.38-2.4-3.51a24.18,24.18,0,0,1-6.21-3.49.06.06,0,0,1,.06-.1,60.35,60.35,0,0,0,5.77,3.08,52.1,52.1,0,0,0-4.07-4.75c-.71-.37-1.42-.74-2.1-1.14a.06.06,0,0,1,0-.1,7.21,7.21,0,0,1,1.6.79C80,64.55,79.18,63.73,78.28,62.94Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,66.72a4.15,4.15,0,0,1,.34.24s0,.08,0,.06-.24-.13-.36-.2A.06.06,0,1,1,78.48,66.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.37 97.32 85.72 97.32 86.64 85.1 86.99 81.11 102.93 81.11 103.28 85.1 104.37 97.32",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.28 85.1 86.64 85.1 86.99 81.11 102.93 81.11 103.28 85.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.72,
    y: 77.84,
    width: 18.48,
    height: 4.09,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.9,
    y: 69.51,
    width: 44.38,
    height: 11.18,
    transform: "translate(219.19 -68.99) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.65,
    y: 47.39,
    width: 4.88,
    height: 11.18,
    transform: "translate(197.07 -91.11) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.18,
    y: 56.98,
    width: 1.81,
    height: 11.18,
    transform: "translate(206.66 -81.52) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.65,
    y: 83.44,
    width: 4.88,
    height: 11.18,
    transform: "translate(233.12 -55.06) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.7,
    y: 67.5,
    width: 51.77,
    height: 7.81,
    transform: "translate(224.99 -82.17) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.59,
    y: 58,
    width: 19.91,
    height: 4.69,
    transform: "translate(213.89 -93.2) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.08,
    y: 72.35,
    width: 51.77,
    height: 7.81,
    transform: "translate(109.04 -112.92) rotate(44.67)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.72,
    y: 76.55,
    width: 19.91,
    height: 4.69,
    transform: "translate(111.68 -114.06) rotate(44.67)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 71.01,
    width: 39.32,
    height: 13.26,
    transform: "translate(241.75 -86.47) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.28,
    y: 84.67,
    width: 3.66,
    height: 13.26,
    transform: "translate(255.41 -72.81) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.4,
    y: 79.72,
    width: 1.42,
    height: 13.26,
    transform: "translate(250.46 -77.76) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.6,
    y: 73.95,
    width: 36.95,
    height: 9.16,
    transform: "translate(249.36 -7.25) rotate(113.23)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.29,
    y: 85.75,
    width: 3.44,
    height: 9.16,
    transform: "translate(253.14 13.84) rotate(113.23)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.95,
    y: 65.56,
    width: 3.44,
    height: 9.16,
    transform: "translate(246.68 -22.27) rotate(113.23)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.14,
    y: 69.92,
    width: 1.34,
    height: 9.16,
    transform: "translate(248.07 -14.47) rotate(113.23)",
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-40"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 419.03,
    rx: 326.84,
    ry: 38.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 344.8,
    rx: 172.33,
    ry: 24.09,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "52 299.26 132.75 299.02 213.5 298.93 375 298.76 536.5 298.93 617.25 299.02 698 299.26 617.25 299.51 536.5 299.59 375 299.76 213.5 299.59 132.75 299.5 52 299.26",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.47,192.2a86.67,86.67,0,0,1,2-14.17c1-4.2,2.42-8.49,5.07-12a15.2,15.2,0,0,1,9.93-6.19c3.88-.47,7.54,1.26,10.44,3.71,3.61,3,6.37,7,9,10.95a134.94,134.94,0,0,1,7.73,13.53c.08.16-.16.29-.23.13a85,85,0,0,0-6.92-11.32,71.49,71.49,0,0,0-8-9.65c-2.67-2.6-6.06-5-9.93-5.16a12.23,12.23,0,0,0-9.72,5c-2.59,3.32-3.9,7.46-4.89,11.49a86.55,86.55,0,0,0-2,13.5c-.76,9.34-1,18.73-1.17,28.1-.12,5.29-.19,10.59-.24,15.89q0,4-.07,8.06a49.13,49.13,0,0,1-.31,7.77c-.08.52-.94.47-1,0a46.3,46.3,0,0,1-.35-7.36c0-2.54-.07-5.09-.09-7.63q-.08-7.43-.06-14.85C98.67,212.08,98.79,202.11,99.47,192.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.81,185.16c.5-2.64,1.39-6.08,2.89-8.13,2.71-3.67,5.63-2.07,2.93,2a24.35,24.35,0,0,0-3.8,10s4.55,6.5,10,9.69c-.23-2.49-.94-6.33-.45-10,1-8,5.9-7.56,4.71-1.19A54.84,54.84,0,0,0,128,200.4a26.91,26.91,0,0,0,5.86,2.87c-.32-.93-.65-2-1-3.4-2-7.19,2.85-9.43,3-5.38a57,57,0,0,0,1.87,10.2c2.63.88,4.81,1.48,6.14,1.95a22.45,22.45,0,0,1,9,6.15,28.22,28.22,0,0,0,6.13-7.93c-1.67-1.44-4.32-3.59-8-6.18-6.89-4.87-4.5-11,1-7.19,3.95,2.75,7,7.86,8.39,10.48a42.78,42.78,0,0,0,3.13-14.35c-5.42-5.08-18.81-12.16-14.77-12.16,3.63,0,11.76,5.32,14.74,7.38a37.11,37.11,0,0,0-.46-4.18c-5.1-3.34-21.67-8.54-19-10,2.9-1.64,14.46,3.71,18,5.4a21.14,21.14,0,0,0-3.06-6.34c-7.05-9.44-19.76-12.69-25.3-10.89-3.92,1.27-2.78,11.23-3.62,10.89C114.18,161.35,107,165.83,112.81,185.16Zm38.63-1.09c1.12-1.35,6.29,2.62,4.79,4.79S150,185.8,151.44,184.07Zm-27-8.49c1.36.87-.65,5.9-2.75,4.37C119.89,178.65,123.05,174.71,124.42,175.58Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.48,177.12c.71-1.4,1.45-2.8,2.27-4.15a23.91,23.91,0,0,1,2.6-3.78c-.23-.28-.44-.56-.67-.83-.1-.11.06-.27.16-.16.26.31.52.61.77.92a.24.24,0,0,1,.11.13c1,1.17,1.89,2.37,2.77,3.59a42.82,42.82,0,0,1,4.58,1.33c1.54.52,3.07,1.06,4.58,1.69.15.07.07.32-.08.26-1.49-.66-3-1.3-4.54-1.82s-2.95-.87-4.43-1.29c.49.68,1,1.36,1.41,2.06a52.59,52.59,0,0,1,8.09,3.3c2.74,1.3,5.37,2.81,8,4.32a.13.13,0,0,1-.14.23,85.18,85.18,0,0,0-7.94-4.11c-2.54-1.19-5.16-2.16-7.72-3.29,6.44,10,10.3,21.63,15.46,32.36.07.15-.17.28-.24.12-1.57-3.76-3.39-7.42-5.1-11.13-1.54-3.32-3-6.66-4.59-10q-.67-1.45-1.38-2.91c.28,5.36.16,10.82,1,16.12a.13.13,0,1,1-.26,0c-.37-5.73-1.38-11.38-1.34-17.14a.15.15,0,0,1,0-.07c-1.09-2.2-2.26-4.36-3.51-6.46-2.13,5-4.38,10.11-5.37,15.5,0,.17-.3.1-.26-.07,1.45-5.41,2.8-10.82,5.4-15.81a61.26,61.26,0,0,0-4.53-6.53c-.72,1.33-1.63,2.59-2.45,3.87s-1.57,2.5-2.31,3.78a55.58,55.58,0,0,0-4,8.51c-.06.16-.32.07-.26-.08C123.83,182.77,125.07,179.9,126.48,177.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.75,189.33c4.13-4.14,8.93-9.57,15.32-9.56,6.16,0,10.69,5,13.29,10.08,2.73,5.35,3.7,11.41,4.47,17.31a207.25,207.25,0,0,1,1.64,21.27c.11,3.95.09,7.9,0,11.85a78.37,78.37,0,0,1-.91,12c-.11.64-1.14.67-1.17,0-.19-3.33-.06-6.67,0-10s0-6.56-.15-9.83c-.25-6.63-.73-13.25-1.51-19.83-.68-5.76-1.22-11.67-2.94-17.23-1.55-5-4.46-10.75-9.54-13-6.94-3-13.71,2.49-18.25,7.12C75.84,189.62,75.63,189.45,75.75,189.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.69,198.59h0c0,.84.08,1.68.13,2.5a15.05,15.05,0,0,1,6.77-2.81c5.86-.62,5.49,3.84,1.57,4a22.27,22.27,0,0,0-8,1.62c1,7.73,3.09,14,3.41,14A112.26,112.26,0,0,0,74,216c-1.46-3.1-4.77-7.23-3.08-7.56s3.54,3.34,4.47,7.28a74.09,74.09,0,0,0,11.27-3.1c-2.58-2.23-6.56-5-5-6.19s4.68,2.73,6.58,5.57a23.19,23.19,0,0,0,4.87-2.72c-3.48-5.1-11.94-6.14-10.84-9.83s9,1.43,12.58,8.26c4.18-4.33,5.4-10.46,5-15.7-3.63-.42-10.63.35-10.13-2.26s5.57-2.12,9.71-.59a14.49,14.49,0,0,0-2.43-5.76c-3.84-4.92-15.54,1.34-15.54,1.34S82.65,173,78.18,171c-2.57-1.16-7.11-1.16-11.66,1.53,2.55.21,5.64,1,6.88,2.79,1.59,2.26-.92,3.49-2.51,2.44-1.12-.74-3.21-3.06-7-3.37A23.16,23.16,0,0,0,59.68,179c-.43.6-.84,1.25-1.24,1.94a16.07,16.07,0,0,1,13.7.25C77.21,183.73,74.38,189,70,187s-8.52-4.06-13.15-2.9a32.82,32.82,0,0,0-2.23,13.11,23.11,23.11,0,0,1,7.52-3.6c5-1.33,6.57,1.69,1,2.25A22.09,22.09,0,0,0,54.69,198.59Zm6.13-8.1c-.35-1.63,3.23-2.1,3.83-.78C65.14,190.84,61.16,192.13,60.82,190.49Zm30.6,9c.34-.89,2.73.12,2.51,1.23C93.63,202.26,91.09,200.43,91.42,199.54Zm-16.89,5.73c1.74-.69,4.46,3.64,2.56,4.63S73.1,205.85,74.53,205.27Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,217.08c2.63-4.4,5.22-8.81,8-13.13,1.29-2,2.64-4,4-5.91-.21,0-.42-.1-.62-.15l-1-.2c-.81-.14-1.62-.25-2.43-.34s-1.54-.12-2.31-.13a12,12,0,0,0-2.47.13.07.07,0,1,1,0-.13c.82,0,1.66-.07,2.49-.08s1.59,0,2.39.05,1.49.12,2.24.24c.41.06.81.13,1.22.21a6.52,6.52,0,0,1,.74.16q2.13-2.94,4.43-5.76a52.88,52.88,0,0,0-14.39-4.59c-.08,0,0-.14,0-.13a48.69,48.69,0,0,1,14.6,4.43c.84-1,1.68-2.06,2.53-3.08s2-2.26,2.83-3.48a.07.07,0,1,1,.11.08,50.85,50.85,0,0,0-3.34,4.09s0,0,0,0a51.11,51.11,0,0,1,5.35,4.3c1.74,1.54,3.45,3.15,5.11,4.79.06.06,0,.16-.09.1-1.64-1.63-3.34-3.18-5.12-4.66s-3.64-2.83-5.43-4.29a0,0,0,0,1,0,0l-1.23,1.61-.62.81s0,0,0,.06l-2,2.67a21.16,21.16,0,0,1,2,3.67c.59,1.24,1.1,2.52,1.57,3.81a55.8,55.8,0,0,1,2.2,8.23c0,.09-.12.13-.13,0a49.2,49.2,0,0,0-2.39-8.07c-.51-1.34-1.1-2.65-1.7-4s-1.2-2.33-1.71-3.53c-.59.78-1.18,1.57-1.76,2.36-.17.23-.32.47-.49.7,0,.05,0,.11-.06.12h0c-1.8,2.52-3.52,5.1-5.19,7.71a2.61,2.61,0,0,1,.23.57q.16.48.3,1a18.41,18.41,0,0,1,.46,1.95c.11.62.2,1.25.26,1.87a16.55,16.55,0,0,0,.16,2.13c0,.11-.15.11-.13,0a7,7,0,0,0-.15-2,20,20,0,0,0-.38-2c-.14-.6-.3-1.21-.48-1.8-.09-.3-.19-.59-.29-.89s-.13-.32-.18-.48c-.78,1.23-1.56,2.46-2.32,3.7-1.51,2.45-3,4.92-4.52,7.38C59.33,217.31,59.13,217.2,59.21,217.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.74,250.82c.07-2.49.46-5,.73-7.47s.56-5,.82-7.46c.51-4.8.8-9.7,1.93-14.4a20.94,20.94,0,0,1,5.85-10.77,9.56,9.56,0,0,1,5.75-2.75,9.91,9.91,0,0,1,6.1,1.88,21.29,21.29,0,0,1,5.13,5.41,52.25,52.25,0,0,1,4,6.5c0,.08-.09.13-.14.05a33.26,33.26,0,0,0-8.65-9.69,10.19,10.19,0,0,0-5.46-2.28,7.46,7.46,0,0,0-5.29,2.11c-2.9,2.53-4.58,6.24-5.58,9.89-1.19,4.32-1.57,8.87-2.16,13.3-.36,2.64-.69,5.27-1,7.91s-.56,5.31-1.12,7.89A.44.44,0,0,1,99.74,250.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,231.48a13.88,13.88,0,0,0,2.71,2.77c-.41-2.43-.9-6.75.32-9.05,1.91-3.57,4.16-1.79,3,1.32a25.32,25.32,0,0,0-1.84,8.8,38.24,38.24,0,0,0,8.28,3.9,14,14,0,0,1-.28-4.26c.38-3.82,3.31-3.74,2.55.23a23.19,23.19,0,0,0-.4,4.66,86,86,0,0,0,12.89,2.91,38.16,38.16,0,0,0,5.34-9.5c-3.11-.78-9.4-1-9.27-3.18.18-3,6.27-.68,9.84,1.48a24,24,0,0,0,1.08-8,40.82,40.82,0,0,0-8.57-1.42c-6.4-.55-6.08-4.17-1.45-4.09,3.42.06,7.75,2.16,9.8,3.24-1.34-8.7-8-14.27-13.3-14.49-8.94-.36-5.72,10.78-5.72,10.78s-6.06-4.27-11.79-4.16S105.87,223,112,231.48Zm23.9-16.09c-.2-1.25,3.79-1.56,4,.05C140.13,217.25,136.09,216.66,135.89,215.39Zm6.42,13.06c-.08-.82,1.64-1,2,.07C144.6,229.19,142.38,229.26,142.31,228.45Zm-21.48.76c1.35.19,2.11,5-.21,4.92C118.85,234.05,119.69,229.05,120.83,229.21Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.69,234.57c.23-.6.43-1.21.62-1.83-.18.62-.33,1.25-.45,1.87C122.84,234.73,122.65,234.69,122.69,234.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,226.82c.42-1.24.89-2.46,1.37-3.67.25-.65.52-1.29.8-1.93a7.88,7.88,0,0,1,.8-1.62,12.16,12.16,0,0,1-.72-1.56s0-.09.08,0a18,18,0,0,1,1.74,2.7c.25.42.49.85.73,1.27a13.16,13.16,0,0,1,1.51.24c.53.1,1.07.21,1.6.33l1.59.37c.53.12,1.05.3,1.59.38a.08.08,0,1,1-.05.16,10.49,10.49,0,0,0-1.67-.43c-.51-.11-1-.2-1.55-.28s-1-.14-1.56-.19-.79-.06-1.19-.09c.22.37.44.74.65,1.12l.09.18a5.68,5.68,0,0,1,1.29.15c.46.09.92.17,1.38.28.93.2,1.86.42,2.78.68,1.94.54,3.85,1.16,5.76,1.78.11,0,0,.2-.07.16a54.94,54.94,0,0,0-5.78-1.6c-.91-.21-1.83-.42-2.75-.61l-1.38-.29a10.28,10.28,0,0,1-1.07-.24c1,1.82,1.92,3.67,2.77,5.55,1.85,4.11,3.42,8.34,5,12.55,0,.1-.13.17-.16.07A116.89,116.89,0,0,0,133.32,230c-.36-.73-.73-1.45-1.09-2.18,0,.15-.07.3-.09.45-.1.5-.18,1-.27,1.49-.17,1-.34,2-.48,3a34.29,34.29,0,0,0-.73,6.22c0,.13-.19.12-.17,0,.16-1,.16-2,.22-3s.15-2.1.27-3.14.24-2,.41-3c.08-.5.17-1,.26-1.5a3,3,0,0,1,.28-1.08c-.52-1-1-2.11-1.57-3.15s-1-2-1.51-2.94c-.22-.42-.45-.83-.68-1.25a12,12,0,0,1-.6,1.5c-.22.57-.46,1.13-.69,1.69-.51,1.25-1,2.51-1.46,3.78-.68,1.78-1.43,3.62-2,5.48C124,230.48,124.44,228.62,125.06,226.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.31,232.74c0-.14.08-.29.13-.43C123.39,232.45,123.35,232.6,123.31,232.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.78 245.98 85.41 259.3 87.03 293.62 122.45 293.62 124.06 259.3 124.69 245.98 84.78 245.98",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.78 245.98 85.41 259.3 124.06 259.3 124.69 245.98 84.78 245.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.26,
    y: 240.6,
    width: 44.95,
    height: 10.77,
    transform: "translate(209.48 491.96) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.36,
    y: 293.62,
    width: 6.22,
    height: 5.64,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.36,
    y: 293.62,
    width: 6.22,
    height: 2.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 293.62,
    width: 6.21,
    height: 5.64,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 293.62,
    width: 6.21,
    height: 2.82,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.11,356c-.63-2.77-42.2-70.14-45.33-71.66-.36-.19-23.06,12.91-23.06,12.91-1,1.09-40.58-11.3-40.58-11.3l-5.05,48.71,73.76,5.45s9.39,6.79,18,12.41c0,0,0,0,0,0,5.31,3.48,10,6.44,11.41,6.94C465.91,360.74,473.76,358.72,473.11,356Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.32,359.44c-1.39-.49-6.1-3.45-11.41-6.94h0c-8.64-5.63-18-12.43-18-12.43l-16.41-1.21L394.73,295c5.54,1.53,9.68,2.53,10,2.18,0,0,22.69-13.1,23-12.9,3.14,1.51,44.71,68.87,45.34,71.64S465.91,360.75,462.32,359.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.54,356.09c-.67-2.84-42.46-70.19-45.68-71.75-1.22-.6-12.23,4.83-23.14,12.88l27,43.39s27,17.79,30.74,19.12S474.21,358.93,473.54,356.09Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.24,356.8c-7.28-11.12-35.6-56.65-41.95-68.19-.06-.1,0-.13.07-.05,7.46,10.87,35.41,56.62,42.07,68.12C470.57,356.93,470.4,357,470.24,356.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.34,356.9a10.7,10.7,0,0,1-1.44-8.46,10.4,10.4,0,0,1,4.47-6.27c.07,0,.14.09.08.14a12.33,12.33,0,0,0-3,14.5A.08.08,0,0,1,457.34,356.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,343.45c-2.86-4.48-4.52-10.71-2.56-15.81.07-.2.35-.09.36.09a73.21,73.21,0,0,0,2.81,15.45A.34.34,0,0,1,435,343.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.57,346.09c-2.87-4.48-4.52-10.7-2.57-15.81.07-.19.35-.08.37.09a73.92,73.92,0,0,0,2.8,15.46A.33.33,0,0,1,438.57,346.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.09,348.74c-2.86-4.48-4.52-10.71-2.57-15.81.08-.2.36-.09.37.09a73.21,73.21,0,0,0,2.81,15.45A.34.34,0,0,1,442.09,348.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.62,351.38c-2.87-4.48-4.52-10.71-2.57-15.81.07-.19.35-.08.37.09a74,74,0,0,0,2.8,15.46A.33.33,0,0,1,445.62,351.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.35,298.14c-3.13-5.08,4.75-10,7.89-4.87S422.48,303.22,419.35,298.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.42,351.34c1.63-4.39,1.3-9.33,1.53-13.93,0-.48-.48-.69-.87-.59a.14.14,0,0,0-.21-.06,27.92,27.92,0,0,0-9,11.28c-1.09,2.63-1.16,6.66,2.16,7.77C429.15,356.86,431.46,353.91,432.42,351.34Zm-3.62,2.54c-5.19,2.6-4.17-4.18-3.28-6.09a28.11,28.11,0,0,1,2-3.54,83.36,83.36,0,0,1,5.11-6.7c-.25,2.25-.3,4.5-.47,6.76C432,347,431.67,352.44,428.8,353.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,322.51c-2.73,2.18-1.28,5.94.65,8A27.91,27.91,0,0,0,433,338a.15.15,0,0,0,.19-.13c.39,0,.8-.41.61-.85-1.8-4.24-3.2-9-6.24-12.55C425.8,322.42,422.61,320.44,420,322.51Zm9.75,8.67c.93,2.06,1.76,4.16,2.77,6.19-2.4-1.47-4.85-2.82-7.11-4.53a31.23,31.23,0,0,1-3.12-2.63c-1.48-1.49-4.78-7.5,1-6.84C426.49,323.73,428.66,328.72,429.78,331.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,275.92s-61.23-30.31-88.94-30.81c-33-.6-59.75,37.75-20.2,67.16,35,26,147.59,27.56,147.59,27.56l-24.89-48s-30.73-13-71.41-15.48l56.47,13.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.34,285.3c-4.83-1.39-9.77-2.37-14.68-3.41s-9.94-2-14.92-2.89a297.83,297.83,0,0,0-30.06-4c-.94-.07-1.89-.13-2.83-.18a5.46,5.46,0,0,0-.61-.21c-.47-.17-.94-.33-1.41-.47-.9-.26-1.8-.48-2.7-.71-1.87-.47-3.76-.85-5.62-1.39a.09.09,0,0,0-.06.18c1.86.6,3.68,1.33,5.54,1.92q.81.27,1.62.51c-3.71-.16-7.42-.22-11.13-.24-.12,0-.14.18,0,.18,5,.19,10.09.63,15.1,1.19s9.94,1.14,14.89,1.9c10,1.54,20,3.4,29.9,5.4,5.57,1.13,11.14,2.36,16.76,3.14C375.66,286.33,375.89,285.45,375.34,285.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.84,337.35c-1.52-3.05-2.77-6.27-4.13-9.4s-2.74-6.27-4.12-9.4c-2.74-6.25-12.71-27.35-13.75-28.85a.11.11,0,0,0-.2.09c.41,1.6,6.56,15.52,8,18.63,2.85,6.22,5.88,12.34,8.86,18.5.85,1.76,1.74,3.5,2.61,5.25s1.8,3.47,2.58,5.26C403.72,337.54,403.89,337.45,403.84,337.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,349.32c.89-2.7,48.66-65.82,51.93-67,.37-.16,21.72,15,21.72,15,.89,1.17,41.48-7.41,41.48-7.41l.4,49-73.94-1.57s-10,5.87-19.12,10.65h0c-5.63,3-10.6,5.46-12,5.83C263.46,354.75,255.83,352,256.74,349.32Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.16,353.81c1.42-.37,6.39-2.87,12-5.83h0c9.13-4.79,19.12-10.67,19.12-10.67l16.45.36,25.77-41.57c-5.66,1-9.88,1.6-10.16,1.22,0,0-21.34-15.19-21.72-15-3.26,1.21-51,64.33-51.93,67S263.46,354.76,267.16,353.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.31,349.4c.93-2.76,48.92-65.84,52.27-67.09,1.27-.48,11.72,6,21.81,15l-31,40.63S270.82,353.1,267,354.08,255.37,352.17,256.31,349.4Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,350.42c8.3-10.38,40.81-53,48.23-63.9.06-.09,0-.14-.06,0-8.46,10.1-40.62,53-48.35,63.82C259.18,350.52,259.34,350.64,259.52,350.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.36,351.75a10.69,10.69,0,0,0,2.23-8.29,10.34,10.34,0,0,0-3.85-6.66c-.07-.05-.16.07-.1.13a12.33,12.33,0,0,1,1.58,14.72A.09.09,0,0,0,272.36,351.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.82,340.47c3.28-4.19,5.52-10.23,4.06-15.5-.06-.2-.34-.12-.38.06a73.12,73.12,0,0,1-4.25,15.12A.33.33,0,0,0,295.82,340.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.07,342.77c3.27-4.19,5.51-10.23,4.05-15.5-.05-.2-.34-.12-.37.06a73.68,73.68,0,0,1-4.26,15.11A.34.34,0,0,0,292.07,342.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.31,345.07c3.27-4.19,5.51-10.24,4.05-15.5-.05-.2-.34-.12-.37.06a73.68,73.68,0,0,1-4.26,15.11A.34.34,0,0,0,288.31,345.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.55,347.36c3.28-4.18,5.51-10.23,4.05-15.49-.05-.2-.34-.12-.37.05A73.59,73.59,0,0,1,284,347,.33.33,0,0,0,284.55,347.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.75,296.85c3.6-4.76-3.79-10.36-7.4-5.59S312.14,301.62,315.75,296.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.64,353.63c3.41-.79,3.72-4.81,2.88-7.53A28,28,0,0,0,298.63,334a.15.15,0,0,0-.23,0,.65.65,0,0,0-.92.5c-.2,4.6-1,9.49.21,14C298.4,351.22,300.42,354.38,303.64,353.63Zm-5.05-12c.05-2.27.21-4.51.17-6.78a80,80,0,0,1,4.46,7.16,30.13,30.13,0,0,1,1.68,3.71c.7,2,1.08,8.83-3.85,5.75C298.33,349.74,298.54,344.3,298.59,341.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.06,322.31c-3.37,3.26-5.22,7.85-7.41,11.9a.65.65,0,0,0,.53.91.14.14,0,0,0,.17.15,27.89,27.89,0,0,0,13-6.28c2.13-1.91,3.93-5.51,1.42-7.95S307,320.41,305.06,322.31Zm4.35-.72c5.81-.1,2,5.57.33,6.91a29.8,29.8,0,0,1-3.35,2.32c-2.41,1.48-5,2.6-7.51,3.83,1.2-1.92,2.22-3.93,3.35-5.89C303.57,326.41,306.21,321.64,309.41,321.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,274.91s63.07-17.38,96.38-12.6c32.64,4.68,45.1,46,12.66,67.52C447.72,353.3,316.71,341.7,316.71,341.7l29.21-49.5s44.92-9.46,85.66-8.09L374.1,292Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,295.39a1,1,0,0,0,.06-.25l.05-.21c0-.16.09-.32.13-.48a9.34,9.34,0,0,1,.34-1c.13-.32.26-.63.41-.94a6.07,6.07,0,0,1,.55-.87s.05,0,.07-.06l.06,0a110694154508.65,110694154508.65,0,0,0,.14-.06c4.94-.92,38.51-5.73,43.51-6.3s10.07-1,15.12-1.46a297.47,297.47,0,0,1,30.3-1.09c.94,0,1.89.05,2.84.08.2-.06.41-.1.62-.15.48-.11,1-.23,1.46-.33.91-.17,1.83-.31,2.74-.45,1.91-.29,3.83-.49,5.73-.85.12,0,.17.15,0,.18-1.91.42-3.79,1-5.71,1.4l-1.65.35c3.7.19,7.4.48,11.1.81.11,0,.12.19,0,.19-5-.3-10.1-.34-15.14-.25s-10,.19-15,.48c-10.11.58-20.21,1.48-30.28,2.54-5.65.59-39.88,5.58-45.55,5.82h-.07a3.2,3.2,0,0,1-.16.39c-.15.31-.31.61-.48.91s-.32.58-.51.86l-.27.41-.15.2a1.64,1.64,0,0,0-.14.22C344.1,295.59,343.9,295.51,344,295.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,338.69c1.81-2.89,3.35-6,5-9s3.32-6,5-9c3.32-6,15.25-26,16.42-27.42a.11.11,0,0,1,.19.11c-.56,1.55-8,14.83-9.72,17.79-3.42,5.92-7,11.73-10.57,17.57-1,1.67-2.07,3.32-3.09,5s-2.12,3.29-3.07,5C327.34,338.89,327.18,338.79,327.24,338.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3,210.61l-4.54.26a11.65,11.65,0,0,0-1.27-3.26c-2.31-4-6.33-7-9.56-10,0,0,0,0,0,0a40.63,40.63,0,0,1,7.92,10.83,10.92,10.92,0,0,1,.85,2.55l-2.83.16a16.22,16.22,0,0,0-3.13-7.15c-.05-.07-.15,0-.11.1a15.26,15.26,0,0,1,2.22,7.11l-24.53,1.38a39.36,39.36,0,0,1-1.41-6.4.18.18,0,1,0-.35.07,53.68,53.68,0,0,0,1.13,6.37l-2,.11a42.42,42.42,0,0,1-.82-11.15.09.09,0,1,0-.18,0,50.09,50.09,0,0,0-.05,11.22l-17,1a45.23,45.23,0,0,0,1.58-7.49.16.16,0,1,0-.32,0,33.77,33.77,0,0,1-2.24,7.57l-2.52.15a37.35,37.35,0,0,0,2.31-13.26.16.16,0,0,0-.31,0c-.09,4.9-2.12,9.13-4.12,13.36l-6.39.37c1.8-3.94,5.26-7.7,5.33-12.16,0-5-4.9-6.9-6.77-10.92-3.13-6.74,0-12.25,4-17.46,3.72-4.81,2.73-9.81,3.13-15.52.3-4.2,1-8.9,2.87-12.71a20,20,0,0,1,18.32-11.25,16.13,16.13,0,0,1,8.37,1.57,0,0,0,0,1,0,0,3.31,3.31,0,0,1,.52.28,20.45,20.45,0,0,1,7.31,6.86l0,0a30.24,30.24,0,0,1,1.68,2.81c.92,1.75,1.35,4.26,2.27,7.1a.6.6,0,0,0,.05.16,21.53,21.53,0,0,0,9.85,12.31c7.32,4.42,6.41,12.77,1.88,21.49-1.92,3.69-1.75,5.94-.61,7.77v0c.17.24.32.46.5.69,1.56,2,4.17,3.6,6.14,6.32A16.64,16.64,0,0,1,412.3,210.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.91,137a21,21,0,0,0-9.2,13.49c-.91,4.41-.53,9.06-1.91,13.37-1.3,4.07-4.05,7.32-6.14,10.94-2.76,4.78-4.21,10.44-.91,15.25,2.05,3,6.15,5.74,6.43,9.77.32,4.71-3.36,9.66-5.16,13.76-.09.19.21.37.31.18,2.57-4.69,7.27-11,4.77-16.55-1.14-2.55-3.18-4.37-4.88-6.47-3.29-4.06-3.26-8.78-1-13.53,3-6.42,7.46-10.81,8.25-18.26.45-4.25.36-8.56,2.08-12.55a21.23,21.23,0,0,1,7.55-9.14C361.2,137.21,361.05,137,360.91,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.4,200.92c-2.15-2.28-4.65-3.87-4.11-7.7.38-2.66,2-5.06,3-7.49,2.49-6,3.44-13.44-.43-19-2.17-3.14-5.3-3.65-8.14-5.83-3.45-2.64-5.15-7.06-6.67-11.15-2.26-6.12-5-13.08-12-13.84-.06,0-.07.09,0,.1,8.88,1.51,10.15,12.11,13.53,19.2a16.92,16.92,0,0,0,4.71,6.27c3.29,2.52,7,3.1,9,7.31,1.93,3.94,1.88,8.53.8,12.78-.94,3.69-3.11,6.91-4,10.58a7.33,7.33,0,0,0,.89,6.22c1,1.43,2.62,2.29,3.72,3.66a11.94,11.94,0,0,1,2.44,6.48c0,.24.37.17.35-.07A12,12,0,0,0,407.4,200.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,190.63c-24.07,22.52-46.32,47.11-47.86,59.48-2.14,17.13,8.45,21.67,13.16,21.63,12.81-.12,35.13-52.49,42.85-72.47C370.65,179.87,360.28,185.68,355,190.63Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.7,226.63l27.5,14.29s16.34-31.58,20-46.15-2.19-14-14.79-2.52S318.7,226.63,318.7,226.63Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.7,226.63l27.5,14.29s16.34-31.58,20-46.15-2.19-14-14.79-2.52S318.7,226.63,318.7,226.63Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.16,194.77c-3.62,14.57-20,46.16-20,46.16l-16.84-8.75,36.64-48C367.55,185.29,367.68,188.73,366.16,194.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.22,222.36c10.63,6.9,20.89,11.33,22.95,12.46.1.06.17-.11.07-.16-2.08-1-13.38-7.75-22.94-12.48C324.19,222.13,324.12,222.29,324.22,222.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.29,236.09,337,273.46s37.59,7.76,81.88,1.06c0,0-13.78-68.54-30.52-86.73-8.38-9.09-18.21-8.41-24.48-2-1.59,1.61-18.16,24.26-20.15,33.81C342,228,346.29,236.09,346.29,236.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.31,233.81a83.87,83.87,0,0,0-12.13,1.57c-2,.44-3.93,1-5.88,1.54-1,.28-1.95.53-2.93.78a13.17,13.17,0,0,1-3.13.48.07.07,0,0,0,0,.14,17.51,17.51,0,0,0,5.87-.39c2-.43,4-.94,6-1.39,4.06-.9,8.11-1.79,12.22-2.39C375.54,234.12,375.5,233.8,375.31,233.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.24,237.75a91.75,91.75,0,0,0-10.07-.83c-1.68,0-3.36,0-5,.13-.81,0-1.61.12-2.41.19s-1.75.29-2.63.36c-.1,0-.1.15,0,.14.84,0,1.68.06,2.52.07l2.51,0c1.68,0,3.36,0,5,0,3.37,0,6.72,0,10.08.15A.14.14,0,0,0,385.24,237.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,187.66c24.76,15.62,51.65,43.52,53.61,60.89,1.94,17.15-7.86,16.32-9.54,16-17.67-3.77-42.77-49.52-52.22-68.22S383,183.79,389.08,187.66Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.42,218.86,404,236.56s-20.25-29.23-25.72-43.21.37-14.21,14.34-4.4S429.42,218.86,429.42,218.86Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.4,215.32c-9.66,8.21-19.27,13.92-21.17,15.31-.09.07-.18-.09-.09-.15,1.93-1.26,12.28-9.4,21.16-15.32C423.4,215.09,423.49,215.25,423.4,215.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,235.35a14,14,0,0,0-1.55.87c-3.05-4.89-2.48-3.76-5.57-8.62-1.52-2.39-3.05-4.77-4.56-7.16s-3-5.08-4.73-7.47c-.05-.07-.14,0-.11.07a77.68,77.68,0,0,0,3.78,6.94c-.28-.34-.54-.7-.84-1-.67-.74-1.32-1.48-1.93-2.28-.09-.12-.29,0-.2.13.58.76,1.1,1.54,1.62,2.34s1.08,1.56,1.65,2.32,1.15,1.42,1.75,2.12c.08.08.15.17.22.25.84,1.43,1.66,2.86,2.54,4.27a72,72,0,0,0,6.17,8.7,16.27,16.27,0,0,0,1.85-1.31C405.77,235.42,405.68,235.33,405.61,235.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.6,189s-15.58,11.45-25,10.39-13.19-9.75-13.19-9.75,11.09-10.77,22.82-8.42C384.21,182.57,392.6,189,392.6,189Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.4,185.3c-.54,1.8-5.88,9.62-11.45,8.77-2.87-.43-1.74-10.53-1.74-10.53l0-.76-.76-10.61,15.12-6.7S378.56,184.79,378.4,185.3Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.15,172.68a21.39,21.39,0,0,1-14,10.1l-.76-10.62,15.14-6.7S379.36,168.76,379.15,172.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.78,158.42c.46,18.68,11.7,20.51,15.72,20.4,3.66-.09,16.09-.88,17.56-19.5S375.7,135,367.33,134.78,349.31,139.75,349.78,158.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.82,154.43a10.37,10.37,0,0,0,1.25-.31,2,2,0,0,0,1.22-.56.68.68,0,0,0,0-.81,1.64,1.64,0,0,0-1.64-.32,2.43,2.43,0,0,0-1.49.9A.71.71,0,0,0,354.82,154.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.83,153.71c-.44,0-.84-.1-1.28-.16a2,2,0,0,1-1.27-.42.65.65,0,0,1-.07-.8,1.64,1.64,0,0,1,1.59-.52,2.42,2.42,0,0,1,1.58.72A.71.71,0,0,1,366.83,153.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.75,158.61c0-.05.1,0,.1.11,0,1.27.29,2.72,1.47,3.07,0,0,0,.08,0,.07C364.9,161.75,364.58,159.82,364.75,158.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.8,157.22c2-.28,2.44,3.8.55,4.06S364.1,157.45,365.8,157.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.62,157.35c.38.2.77.57,1.21.57s.83-.46,1.12-.91c0,0,.07,0,.07,0,.09.78-.13,1.62-1,1.82s-1.37-.46-1.64-1.23C366.36,157.5,366.47,157.27,366.62,157.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.44,159c0-.05-.09.07-.09.12.12,1.27,0,2.74-1.09,3.23,0,0,0,.08,0,.07C357.66,162.14,357.75,160.18,357.44,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.23,157.74c-2.05,0-2,4.07-.07,4.11S358,157.77,356.23,157.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.38,158c-.32.22-.63.62-1,.66s-.79-.4-1.08-.82c0-.05-.07,0-.07,0,0,.79.27,1.6,1,1.74s1.18-.56,1.35-1.35C355.63,158.16,355.51,157.94,355.38,158Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,168.65c-.2.38-.35.87-.78,1a3.3,3.3,0,0,1-1.4.13s-.06.06,0,.08a1.7,1.7,0,0,0,1.75.14,1.33,1.33,0,0,0,.59-1.38C366.12,168.59,366,168.6,366,168.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.83,164.69s-.1,1.91,0,2.81a4.85,4.85,0,0,0,4.55-1.86c.06-.08-.07-.17-.15-.11a6.35,6.35,0,0,1-3.77,1.45c-.09-.24.27-3.27.13-3.27a8,8,0,0,0-2,.63c.08-4,.81-7.94.83-11.92,0-.14-.21-.17-.24,0a64.64,64.64,0,0,0-1.44,12.81C357.7,165.7,359.48,164.87,359.83,164.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,167.29a4.67,4.67,0,0,0,2,1.24,2.05,2.05,0,0,0,1.27-.06c.88-.33.82-1.17.57-1.87a4.75,4.75,0,0,0-.52-1A6,6,0,0,1,361,167.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,168.53a2.05,2.05,0,0,0,1.27-.06c.88-.33.82-1.17.57-1.87A2.16,2.16,0,0,0,363,168.53Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.89,160.51c-3.45.78-5.13-7.11-5.13-7.11s-15.1-1.05-17.56-13A20.52,20.52,0,0,1,350,152.6s-.8-13.3,9.46-16.92c0,0,12.57-6,20.93,3.58S384.2,160,381.89,160.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.13,160.83s3.4-6.25,6.2-5.1.68,9.89-2.28,11.39a3.17,3.17,0,0,1-4.4-1.22Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.66,158.22a0,0,0,0,1,0,.08c-2.06,1.12-3,3.25-3.54,5.42a1.74,1.74,0,0,1,2.54-.76c.06,0,0,.13-.05.12a2,2,0,0,0-2.05.91,9.21,9.21,0,0,0-.82,1.84c-.08.2-.44.14-.4-.09,0,0,0,0,0-.06C381,162.93,382.73,158.83,385.66,158.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.62,166.47a.81.81,0,0,1-.91.67.8.8,0,0,1-.67-.92.79.79,0,0,1,.91-.67A.8.8,0,0,1,383.62,166.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06,139.5a13.27,13.27,0,0,0,1.21,5.45,13.77,13.77,0,0,0,3.29,4.61,13.49,13.49,0,0,0,1.1.9l.56.44c.2.13.41.24.61.36.41.24.82.49,1.24.71s.87.37,1.3.54c.22.09.44.19.66.26l.68.19,1.35.37c.92.16,1.85.28,2.77.38-.89-.29-1.79-.48-2.66-.78l-1.29-.47-.64-.24c-.21-.09-.41-.2-.61-.3l-1.22-.61c-.39-.22-.77-.48-1.15-.72l-.57-.36-.53-.42c-.34-.3-.72-.54-1-.87a16.45,16.45,0,0,1-4.36-6.77A16.42,16.42,0,0,1,359.06,139.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07,271.62c8-1,12.77-15.82,22-39.31,1.62-4.13-18.64-28.2-21.5-24.43-3.61,4.76-16.86,30.63-18.22,35.14C299.19,256.82,311.72,272.84,321.07,271.62Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.61,256.08c.66-2,1.41-4,2.17-6s1.57-4,2.37-6,1.64-3.93,2.49-5.88c.44-1,.85-2,1.26-2.94s.84-2,1.19-3a37.9,37.9,0,0,1-1.73,6.19c-.69,2-1.48,4-2.29,6s-1.66,3.93-2.58,5.86S334.65,254.21,333.61,256.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.43,233.59s-5.18-21.41-5.68-24.07c-.63-3.35,5.31-34,3.47-35.26-3-2-24.84,21.74-28.4,26.43-2.72,3.58-10,28.62-10,28.62Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref2), /*#__PURE__*/React.createElement("path", {
    d: "M360.82,233.49s-5.17-21.41-5.67-24.06c-.63-3.36,6.91-33.93,5.07-35.17-3-2-26.45,21.64-30,26.33-2.71,3.58-10,28.63-10,28.63Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.45,206.77a4.82,4.82,0,0,1,.76,0,11.52,11.52,0,0,0-.06,2.64c.17.91.89,4,1.76,7.72a5.56,5.56,0,0,1-1.87.44,5.41,5.41,0,0,1-.59-10.81Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72,226.47a5.41,5.41,0,1,0-5.11,5.7A5.4,5.4,0,0,0,346.72,226.47Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.4,206.87h0a5.41,5.41,0,1,1-2.3,6.59C325.87,211.14,326.66,208.87,327.4,206.87Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.96,
    cy: 195.9,
    r: 5.41,
    transform: "translate(-31.13 322.63) rotate(-48.45)",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.52,179.84h.6c-.42,2.93-1.12,6.71-1.87,10.58a5.41,5.41,0,0,1,1.27-10.58Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,235.75c9.47,1.4,16.94,1.2,21.18.08,4.64-1.24,5.66-3.49,5.43-5.71-.21-2-1.77-3.78-5.5-4-4.88-.27-12.17-.21-18.14-1-6.3-.86-12.23-2.71-16.74-3.51-4.3-.77-7.06-.52-8.1,2.25s-.21,5.16,3.58,7.06C324.5,233.06,332.42,234.86,338.46,235.75Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,235.75c9.47,1.4,16.94,1.2,21.18.08,4.64-1.24,5.66-3.49,5.43-5.71-.21-2-1.77-3.78-5.5-4-4.88-.27-12.17-.21-18.14-1-6.3-.86-12.23-2.71-16.74-3.51-4.3-.77-7.06-.52-8.1,2.25s-.21,5.16,3.58,7.06C324.5,233.06,332.42,234.86,338.46,235.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12), /*#__PURE__*/React.createElement("path", {
    d: "M320.35,198.69a4,4,0,0,1,3.76-2.89s-2.41-3-.95-5.83c.75-1.46,3.74-1.54,3.74-1.54s-1.82-2.48-.37-4.93c1.15-1.94,4-1.73,4-1.73s-.64-3.2,1.18-4.8c3.67-3.26,21.33,4.85,21.07,12.61-.12,3.61-4.33,1.4-4.33,1.4s5.28,4.64,3.7,8.32-6.87.48-6.87.48,5.08,4.54,3.06,8.2-6.85-.31-6.85-.31,2.7,4.46.52,6.9c-3.62,4-8.34-5.29-12.64-6.15l-5.08,5.41S319.29,202,320.35,198.69Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,181.73a.05.05,0,1,1,0-.1,33.75,33.75,0,0,1,17.69,9.44c.14.16-.05.47-.25.33A69,69,0,0,0,331,181.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.83,188.35c-.07,0,0-.14.05-.13,6.65,1.33,14.1,5.31,18.65,11.49.16.22.09.56-.11.33C342.08,196.16,332.74,190.48,326.83,188.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.65,208.22c-4.6-5.76-10.58-9.46-17.27-12.38-.08,0,0-.16.06-.15,3.66.54,7.73,2.85,10.75,4.91a19.37,19.37,0,0,1,6.66,7.46C341.91,208.18,341.75,208.34,341.65,208.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,264.49c-7.64,1.49-17.58-4-43.49-20.74-3.58-2.33,6-32,10-29.75,5,2.87,23.69,15.11,24.95,16.18C438.27,239.19,441.44,263.48,436.26,264.49Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.11,222.3s-7.65-9.56-13.22-13.33c-7.46-5.06-16-6.35-19.58-6.68-7.52-.68-26.18,2.87-26.1,8.43.08,5,19,.43,19,.43s-20,1.5-18.83,7.54,22.83-.55,22.83-.55-20.54,2-18.32,8c1.69,4.55,21.61-.3,21.61-.3s-17.65,1.85-16.12,6.6c1.69,5.26,20.36,1.93,20.36,1.93,5.93,11.44,13.43,14.47,19,16C404.08,250.76,412.11,222.3,412.11,222.3Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.08,210.18c-2.36.09-4.75.17-7.1.47s-4.67.69-7,1.21a41.17,41.17,0,0,0-8.77,2.86c5.14-1.92,13.51-3.13,15.86-3.43s4.66-.72,7-1C379.15,210.26,379.13,210.18,379.08,210.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,218.62c-3,.25-6,.39-9,.77s-5.78,1-8.73,1.58c-.23.05-.13.15.1.12,3-.47,5.75-.67,8.73-1.1s5.93-1,8.91-1.29C380.38,218.69,380.36,218.62,380.32,218.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.69,225.68A67.55,67.55,0,0,0,369,227.9c-.22,0-.08.18.15.14,4.53-.83,8.08-1.51,13.53-2.2C382.78,225.83,382.78,225.67,382.69,225.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.52,225.33a58.83,58.83,0,0,1,6.06,3.83c1,.69,1.92,1.44,2.84,2.23a14.54,14.54,0,0,1,2.47,2.72,33.13,33.13,0,0,1,3.36,6.4,29.77,29.77,0,0,1,2,6.91,35.25,35.25,0,0,0-1.23-3.35c-.44-1.1-.91-2.19-1.43-3.25a47.26,47.26,0,0,0-3.48-6.13,13.77,13.77,0,0,0-2.28-2.6c-.85-.81-1.77-1.55-2.68-2.32s-1.84-1.49-2.79-2.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.18,410.14c-2.89,1.12-86.81,2.64-90.1.76-.35-.21-.26-3.91-1.49-13.49-.06-.46-2-2.24-5-4.74-11.23-9.41-37.6-29.24-37.6-29.24L361.91,327l40.59,39.9,10.55,10.37s34.29,18.51,37.69,21S457.07,409,454.18,410.14Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.18,410.14c-2.89,1.12-86.82,2.64-90.1.77-.35-.21-.25-3.92-1.49-13.5-.06-.46-2-2.23-5-4.75-3.9-3.27-5.75-4.76-11.56-9.28l53.25-19.58,3.19,3.14,10.55,10.37s34.29,18.51,37.68,21S457.07,409,454.18,410.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460,411.3c-2.91,1-92.33,2-95.55,0-.75-.46-1.45-5.66-2-12.77-.07-.89-9.13-8.13-10.37-9.47l54.79-18.46,6.92,6.51s40.33,18.77,43.62,21.32S462.88,410.29,460,411.3Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.72,408c-14-.18-76.36.42-90.26,1.31-.11,0-.11.08,0,.09,13.92.48,76.23-.58,90.27-1.17C459,408.18,459,408,458.72,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.22,377.71c-5.54-1-12.28,0-16.46,4-.16.16.06.38.24.32a78,78,0,0,1,16.21-3.57A.35.35,0,0,0,418.22,377.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.24,380.07c-5.54-1-12.29,0-16.46,3.95-.17.15.06.38.23.32a78.21,78.21,0,0,1,16.22-3.57A.35.35,0,0,0,422.24,380.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.26,382.43c-5.54-1-12.29,0-16.47,3.95-.16.15.06.38.24.32a77.34,77.34,0,0,1,16.21-3.57A.35.35,0,0,0,426.26,382.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.27,384.79c-5.53-1-12.28,0-16.46,3.94-.16.16.06.39.24.33a78,78,0,0,1,16.21-3.58A.35.35,0,0,0,430.27,384.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.28,364.81c-2.21-3-6.23-1.57-8.52.4A29.42,29.42,0,0,0,411.4,378a.14.14,0,0,0,.13.19.69.69,0,0,0,.88.68c4.54-1.74,9.61-3,13.49-6.13C428.16,370.91,430.37,367.62,428.28,364.81Zm-9.53,10c-2.21.91-4.46,1.71-6.64,2.7,1.64-2.48,3.17-5,5.05-7.34a30.34,30.34,0,0,1,2.9-3.2c1.62-1.51,8.09-4.77,7.19,1.3C426.75,371.6,421.39,373.7,418.75,374.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.33,376.69c4.58,1.89,9.82,1.73,14.67,2.14.5,0,.74-.49.65-.9a.14.14,0,0,0,.07-.22,29.48,29.48,0,0,0-11.58-9.94c-2.74-1.25-7-1.47-8.29,2C391.62,373,394.66,375.58,397.33,376.69Zm-2.54-3.91c-2.55-5.59,4.57-4.26,6.56-3.25A31.39,31.39,0,0,1,405,371.8a86.92,86.92,0,0,1,6.89,5.65c-2.37-.35-4.75-.49-7.13-.75C401.94,376.39,396.2,375.85,394.79,372.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.07,364.71,351.3,391.54s-53.93-48.83-58.87-49.19-77.5,48.87-114,49c-37.84.16-39.75-39.48-39.75-39.48l55.19-12.68c39.78-19.6,81.22-54.82,108.32-51.53C331.61,291.26,403.07,364.71,403.07,364.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.43,357.88c-8.74,4.32-6.29,3-15,7.37-4.26,2.16-25.66,13-29.3,15.64-.08.06,0,.2.09.16,4.28-1.43,25.45-12.69,29.66-14.93,8.61-4.57,6.09-3.34,14.65-8A.13.13,0,1,0,390.43,357.88Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.14,379.17c-10.12-8.93-43.29-38-44.63-39.06a18.75,18.75,0,0,0-3.45-2.59,3.69,3.69,0,0,0-3.2.26c-1.53.71-3,1.5-4.55,2.24l-9,4.38c-11.59,5.66-23.13,11.47-34.81,17-11.24,5.26-19.27,10.22-31,14.27a176.82,176.82,0,0,1-36,8.58c-1.51.19-3,.34-4.54.49a.09.09,0,0,0,0,.17,145,145,0,0,0,35.44-6.59C218,374.69,225.92,370.05,237,365c11.44-5.27,22.73-10.91,34-16.51,6-3,11.9-5.95,17.87-8.88,1.36-.66,3.29-2.1,4.83-1.39a8.53,8.53,0,0,1,1.79,1.32l2,1.65c2.56,2.13,43.21,37.14,44.54,38.15C342.1,379.39,342.23,379.25,342.14,379.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.55,351.9s-6.19,35.79,11.71,49.85,149,12.37,168.91,5.94,20.51-38.54-1.23-46c-20.69-7.08-108.69-10.52-110.86-11.39-.55-.21,7.8-5.22,7.76-5.52l-20-6.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.72,351c0-.16-.26-.11-.26,0a17.77,17.77,0,0,1-4.14,11.37c-3,3.51-7.54,5.48-11.61,7.54-.39.2-.1.81.31.69a35.72,35.72,0,0,0,7.19-3.1,17.21,17.21,0,0,0,5.4-4.49A15.43,15.43,0,0,0,165.72,351Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.63,346.56c-.9-1.16-1.89-2.26-2.84-3.39-2.24-2.67-4.49-5.35-6.84-7.92-.23-.24-.66.1-.46.37,1.59,2.07,3.26,4.07,4.91,6.09l2.54,3.09a18.64,18.64,0,0,1,2.38,3c.61,1.15-.2,2.13-1.38,2.25a4.13,4.13,0,0,1-2.87-1.05,37.88,37.88,0,0,1-4.85-5.19q-1.41-1.59-2.85-3.17c-1-1.12-2.1-2.17-3.12-3.29-.06-.07-.19,0-.13.11.89,1.22,1.71,2.49,2.6,3.71s1.79,2.43,2.71,3.63,1.76,2.24,2.69,3.33a11.15,11.15,0,0,0,2.73,2.44c1.7,1,4.66,1.22,5.56-1A3.09,3.09,0,0,0,205.63,346.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.45,407.81c-6.85.12-13.7.52-20.55.67s-13.59.18-20.39.12Q255,408.41,234.6,407c-13.76-.95-28.6-2.32-42.27-4.22-6.54-.9-13.17-1.66-19.63-3.05a30.93,30.93,0,0,1-15.49-7.91c-8.85-8.59-12.3-21.21-13.71-33.27-.19-1.62-.35-3.24-.48-4.87a.08.08,0,1,0-.16,0c.79,12.37,2.72,25.26,10.5,35.2A30.81,30.81,0,0,0,166,398.74c6.12,2.45,12.91,3,19.38,3.91,13.72,1.86,28.62,3.29,42.42,4.36s27.82,1.75,41.75,2,27.87,0,41.78-.68c1.7-.08,3.39-.18,5.09-.33A.08.08,0,0,0,316.45,407.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.26,355.19c-4.31-.63-8.62-1.25-12.95-1.7s-8.76-.85-13.15-1.22c-8.67-.73-17.37-1.39-26.07-1.8-4.94-.23-9.88-.26-14.82-.19-.16,0-.15.22,0,.24,8.7.79,17.4,1.33,26.11,1.91s17.37,1.34,26,2.17c4.92.47,9.84.83,14.77,1.23C273.55,355.86,273.62,355.25,273.26,355.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.87,344.37a68.28,68.28,0,0,0-10,5.34,80.49,80.49,0,0,0-9.24,6.47c-.09.07,0,.17.1.13,3.39-1.57,6.65-3.53,9.87-5.4a92.62,92.62,0,0,0,9.45-6.08C216.29,344.67,216.16,344.25,215.87,344.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.42,281.33c10.59,16.26,28.93,36.2,38.33,34,12-2.85,23.64-50.54,25.18-51.75,3.79-3-20.36-25.68-24.55-22.64-6.37,4.63-12,39.36-14.46,39.29s-9.82-6.73-19.92-12.31C173.28,260.86,173.46,269.09,181.42,281.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48,263.54c2.82-2,15.58-13.24,18.31-16.88s9.85-14.69,7.27-17.07-4.91.69-4.91.69,2.26-5.14-.55-7.3-6.3,2.74-6.3,2.74,1.94-5.45-1-7.4-5.64,3.56-5.64,3.56,2-4.9-1.11-5.49c-3.74-.7-6.42,8.76-9.74,12.55-.76.86-16.53,16.37-16.53,16.37Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.89,221.41c-2,6.94-4.06,9.64-9.36,14.38-.1.09,0,.27.13.18,5.61-4.17,8.7-7.18,9.57-14.48C251.27,221.13,251,221.08,250.89,221.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.45,225.17c-2.69,7-4.91,10-10.1,15.34-.07.08.05.21.13.14,5.53-4.84,8.54-7.91,10.31-15.29C257.87,225,257.58,224.84,257.45,225.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,230.55c-3.1,6.62-5.4,9.95-11.11,14.52a.14.14,0,0,0,.16.22c6.27-4.09,9.17-8.23,11.14-14.63C264.2,230.23,264.07,230.13,263.88,230.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.49,233.25s-18.64,10.27-20.86,11.65c-2.8,1.73-20.8,26-22.89,25.46-3.39-.81-.69-31.89.33-37.49.78-4.27,13.89-25.8,13.89-25.8Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref13), /*#__PURE__*/React.createElement("path", {
    d: "M281.37,232.17s-18.64,10.28-20.85,11.65c-2.81,1.73-19.69,27.05-21.78,26.54-3.39-.81-1.81-33-.78-38.57.78-4.27,13.88-25.8,13.88-25.8Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.16,245.05a6.51,6.51,0,0,0,.51.54,12,12,0,0,1,1.84-1.77c.76-.47,3.45-2,6.65-3.77a5.27,5.27,0,0,0-.91-1.63,5.23,5.23,0,0,0-8.09,6.63Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.18,226.69a5.23,5.23,0,1,1,.73-7.36A5.23,5.23,0,0,1,267.18,226.69Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.6,225.69h0a5.16,5.16,0,0,0,1.07,2.24,5.23,5.23,0,1,0,2.13-8.17C242.65,221.83,241.54,223.87,240.6,225.69Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24,248a5.23,5.23,0,1,1,.73-7.36A5.23,5.23,0,0,1,246.24,248Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.27,266.22l.39.43c1.81-2.21,4.06-5.17,6.33-8.23a5.23,5.23,0,0,0-6.72,7.8Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,214.75c7.17,5.84,11.9,11.3,13.86,15.05,2.15,4.12,1.2,6.31-.53,7.6s-3.85,1.2-6.43-1.33c-3.36-3.3-8.08-8.54-12.56-12.26-4.73-3.93-9.91-7-13.43-9.64-3.35-2.56-5-4.7-3.67-7.25s3.55-3.51,7.37-2C257.38,206.55,263.84,211,268.41,214.75Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.41,214.75c7.17,5.84,11.9,11.3,13.86,15.05,2.15,4.12,1.2,6.31-.53,7.6s-3.85,1.2-6.43-1.33c-3.36-3.3-8.08-8.54-12.56-12.26-4.73-3.93-9.91-7-13.43-9.64-3.35-2.56-5-4.7-3.67-7.25s3.55-3.51,7.37-2C257.38,206.55,263.84,211,268.41,214.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,247.54s2.05-8.14,6.89-13.16c2.82-2.94,16.51-11.36,18.45-8.45,2.51,3.75-4.6,10.08-8.49,12.72,0,0,5.82,8.68,1.69,14.32S216.6,247.54,216.6,247.54Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29,227.19c-.18,5.07-5.5,8.21-9.08,11.05a.42.42,0,0,0,0,.69c2.19,3.8,4.18,9.8,2.21,14a.1.1,0,0,0,.18.1c2.72-4.21,1.25-10.26-1.41-14.27,3.71-2.86,8.92-6.24,8.14-11.57C242.34,227.16,242.3,227.15,242.29,227.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.78,278.8l-17.6,16.37s-8.91-12.32-13.32-19.27c-5.83-9.19-3.41-14.31,9.13-9.74C193.42,269.24,206.78,278.8,206.78,278.8Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.32,277.1c-2.65,2.23-5.26,4.49-7.74,6.9-1.23,1.21-2.45,2.43-3.64,3.68s-2.23,2.64-3.44,3.87c-.06.06.08.19.14.12,1.13-1.3,2.48-2.42,3.69-3.64s2.44-2.43,3.68-3.64c2.46-2.41,4.92-4.83,7.45-7.17C203.53,277.16,203.4,277,203.32,277.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.14,285l-11,10.19s-8.91-12.32-13.32-19.27c-2.57-4-3.53-7.3-2.74-9.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,343.73,136.93,358.6c-.12-1.58,5.08-48.76,11.43-66.67,8.14-23,13.41-25.34,16.55-26.88,4-2,11.53-2.07,13.39-1.44,2.11.71,9.75,11.12,13,19C197.7,298.52,213.91,342.62,213,343.73Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,335.44a6.6,6.6,0,0,0,1.63,2,6.71,6.71,0,0,0,2.2,1.3,6.45,6.45,0,0,0-1.64-2A6.76,6.76,0,0,0,166.91,335.44Zm14.19-60.26a6.7,6.7,0,0,0,1.63,2,6.54,6.54,0,0,0,2.19,1.29,6.66,6.66,0,0,0-1.63-2A6.77,6.77,0,0,0,181.1,275.18ZM203,325.73a6.53,6.53,0,0,0,1.62,2,6.77,6.77,0,0,0,2.19,1.3,6.68,6.68,0,0,0-1.62-2A6.88,6.88,0,0,0,203,325.73Zm-56.31-13.86a7.17,7.17,0,0,0,2-1.62,6.84,6.84,0,0,0,1.29-2.21,6.66,6.66,0,0,0-2,1.63A7.08,7.08,0,0,0,146.66,311.87Zm12.6-30.4a6.87,6.87,0,0,0,2-1.63,6.79,6.79,0,0,0,1.31-2.19,7.31,7.31,0,0,0-3.28,3.82Zm41.65,63.66a6.53,6.53,0,0,0,2-1.62,6.64,6.64,0,0,0,1.29-2.19,6.47,6.47,0,0,0-2,1.62A6.77,6.77,0,0,0,200.91,345.13Zm-23.06-36.68a7.31,7.31,0,0,0,3.28-3.82,6.68,6.68,0,0,0-2,1.62A7,7,0,0,0,177.85,308.45Zm-28.43,38.93a6.81,6.81,0,0,0,2.56.25,7,7,0,0,0,2.46-.65,6.48,6.48,0,0,0-2.53-.23A6.59,6.59,0,0,0,149.42,347.38Zm12.75-30.93a7.45,7.45,0,0,0,5-.39,7.17,7.17,0,0,0-2.54-.26A7.07,7.07,0,0,0,162.17,316.45Zm34.16-6.75a6.68,6.68,0,0,0,2.54.24,6.58,6.58,0,0,0,2.46-.63,7.27,7.27,0,0,0-5,.39Zm-14.61,34.71a7.45,7.45,0,0,0,5-.39,7.29,7.29,0,0,0-5,.39Zm-34-50.69a6.33,6.33,0,0,0,1.74-.53,4.86,4.86,0,0,0-1.48-.26C147.93,293.19,147.84,293.46,147.76,293.72Zm27.09-4.93a6.68,6.68,0,0,0,2.54.24,7.21,7.21,0,0,0,2.47-.63,6.53,6.53,0,0,0-2.54-.25A6.24,6.24,0,0,0,174.85,288.79Zm-6.24-23.71a7,7,0,0,0,.64,2.48,6.77,6.77,0,0,0,.24-2.55,9.51,9.51,0,0,0-.19-1.27,5.43,5.43,0,0,0-.68.13A9.79,9.79,0,0,0,168.61,265.08Zm17.82,61.2a6.84,6.84,0,0,0,.64,2.47,6.49,6.49,0,0,0,.24-2.54,6.73,6.73,0,0,0-.63-2.47A6.94,6.94,0,0,0,186.43,326.28Zm-36.86,1.92a6.58,6.58,0,0,0,.63,2.47,7.26,7.26,0,0,0-.39-5A6.65,6.65,0,0,0,149.57,328.2Zm44.83-34.8a7,7,0,0,0,.64,2.47,6.74,6.74,0,0,0,.24-2.54c0-.2-.05-.42-.08-.62v0c-.21-.53-.42-1.07-.61-1.59A7,7,0,0,0,194.4,293.4Zm-32.47,5.07a7,7,0,0,0,.64,2.47,6.52,6.52,0,0,0,.24-2.54,6.78,6.78,0,0,0-.63-2.48A7,7,0,0,0,161.93,298.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.91,270.22c-25.08,26.1-61.64,92.21-66.16,101.69-3.07,6.44,30.57,23.4,32,18.72,1.83-6,31.13-80,38.92-107.89C168,267.34,164.09,264.82,158.91,270.22Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.33,386.21c-1.17,3.2-5.16,16.82-8,18.51s-17.45,1.34-24.84,1.34-8.85-2.06-8.73-4.61,15.63-3,15.63-3-20.71,5.94-25.92,6.91-17.21,4-18.94-.32c-.79-1.95,2.5-3.92,2.5-3.92s-5,1.47-5.84-1c-.91-2.85,3.1-4.42,3.1-4.42s-3.15.63-3.22-1.69c-.17-5.19,19.53-7.74,19.53-7.74s-15.08,7.34-15.56,3.11c-.68-5.87,30.23-12.29,33.45-14.85a21.87,21.87,0,0,0,5.15-6.36Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92,402.74a2.28,2.28,0,0,1,.7-2,6.25,6.25,0,0,1,1.8-1.16,24.06,24.06,0,0,1,4.23-1.38c2.91-.74,5.9-1.26,8.87-2a36.47,36.47,0,0,0-9.12,1A16.75,16.75,0,0,0,87,398.88a6.06,6.06,0,0,0-1.82,1.57A2.35,2.35,0,0,0,84.92,402.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.07,401.09c2.13-.52,4.23-1.12,6.33-1.73s4.18-1.25,6.27-1.88l6.23-2c2.08-.65,4.16-1.3,6.26-1.93a49.29,49.29,0,0,0-6.47,1.16c-2.13.49-4.24,1.1-6.33,1.73s-4.16,1.34-6.21,2.12S60.06,400.16,58.07,401.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.16,388.43a41.42,41.42,0,0,0-6,.83,56.37,56.37,0,0,0-5.85,1.5,54.85,54.85,0,0,0-5.65,2.11,42.43,42.43,0,0,0-5.36,2.77c1.9-.66,3.75-1.39,5.65-2s3.77-1.29,5.67-1.87,3.81-1.16,5.73-1.72S76.22,389,78.16,388.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.12,383.49a39.95,39.95,0,0,0-18.26,6.24c3.06-1.09,6-2.24,9.08-3.25S72,384.48,75.12,383.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.56,298.37l29.27,1s4-14.17,5.14-22.32c1.48-10.78-2.18-13.86-12.25-5.1C148,277.85,132.56,298.37,132.56,298.37Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.26,299.29c.32-.05,3.33,0,3.54,0,.43-1.68.84-3.36,1.29-5,.23-.84.47-1.67.72-2.5s.54-2,.78-2.77c0-.13.21-.09.18,0-.21,1.08-.41,1.88-.6,2.81s-.36,1.67-.57,2.5c-.44,1.75-.83,3.63-1.35,5.36a30.26,30.26,0,0,1-4-.33C158.2,299.38,158.21,299.3,158.26,299.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.63,295.7c4.27-.14,8.53-.22,12.8-.12,2.13.06,4.26.14,6.39.26s4.25.45,6.37.54c.12,0,.1.19,0,.18-2.11-.2-4.27-.11-6.4-.19s-4.26-.16-6.39-.22c-4.25-.12-8.51-.24-12.77-.27C135.49,295.88,135.51,295.71,135.63,295.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.51,279.29c-4.38,1.12-12.07-5.48-15.15-10.88-.21-.37.29-4.33.67-9.16.22-2.93.4-6.21.35-9.2,0-.62,18.88,4.22,18.88,4.22a47.61,47.61,0,0,0-1.61,11.55,5.9,5.9,0,0,0,.15,1.22l0,.21C183.25,269.58,183.75,278.2,179.51,279.29Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.53,250.1c1,5.06,4.34,17.24,14.37,17.29a12.77,12.77,0,0,0,1.93-.14,1.05,1.05,0,0,0,0-.21,7.81,7.81,0,0,1-.16-1.22,47.83,47.83,0,0,1,1.62-11.55S170.63,250.78,166.53,250.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.43,230.4c-1.11,6.88,5,25.48,10.29,29.08,7.65,5.23,18.88,4.29,23-4.62,4-8.63-4.41-32.73-10.19-35.87C175,214.36,162.06,220.23,160.43,230.4Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.23,236a15.29,15.29,0,0,0,1.56-.8,2.83,2.83,0,0,0,1.43-1.11.9.9,0,0,0-.29-1.06,2.21,2.21,0,0,0-2.26.07,3.28,3.28,0,0,0-1.68,1.66A1,1,0,0,0,176.23,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.35,232a16.91,16.91,0,0,1-1.74.1,2.85,2.85,0,0,1-1.8-.24.9.9,0,0,1-.29-1.06,2.23,2.23,0,0,1,2-1.08,3.27,3.27,0,0,1,2.29.58A1,1,0,0,1,189.35,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.37,251.82a2,2,0,0,0,1.29.4,3.51,3.51,0,0,0,1.25-.76s.09,0,.07,0a1.77,1.77,0,0,1-1.37,1.2,1.4,1.4,0,0,1-1.34-.8C182.22,251.85,182.31,251.79,182.37,251.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.48,247.64a4.5,4.5,0,0,0,3.46,1,5.41,5.41,0,0,0,1.56-.43,1.48,1.48,0,0,0,.29-.12l.26-.13a.34.34,0,0,0,.16-.37h0a.67.67,0,0,0-.06-.12h0l0-.11c-.28-1-.85-2.41-.85-2.41.41.06,2.47.29,2.28-.21a68.29,68.29,0,0,0-5.82-12.4.12.12,0,0,0-.22.11c1.38,4,3.45,7.73,4.9,11.73a7.77,7.77,0,0,0-2.22,0c-.12.09,1.15,2.77,1.24,3.22a.06.06,0,0,1,0,0,6.2,6.2,0,0,1-4.87,0C182.44,247.44,182.37,247.56,182.48,247.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.78,247.89a5.33,5.33,0,0,1-1.53,2.22,2.39,2.39,0,0,1-1.36.54c-1.08.06-1.4-.86-1.47-1.7a5.71,5.71,0,0,1,.06-1.35A6.89,6.89,0,0,0,186.78,247.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25,250.11a2.39,2.39,0,0,1-1.36.54c-1.08.06-1.4-.86-1.47-1.7A2.47,2.47,0,0,1,185.25,250.11Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.27,236.27a1.86,1.86,0,0,0-.74-.67,1.35,1.35,0,0,0-1.08,0,1.26,1.26,0,0,0-.7.86,2.14,2.14,0,0,0,0,1,3.38,3.38,0,0,0,.2.56,2.57,2.57,0,0,0,.72,1,4.13,4.13,0,0,1-.32-.84,5.62,5.62,0,0,1-.15-.8c-.05-.54.06-1.07.45-1.21a1.06,1.06,0,0,1,1.21.43,8.19,8.19,0,0,1,1,1.41A3.88,3.88,0,0,0,190.27,236.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.65,239.62a1.91,1.91,0,0,0-.64-.76,1.34,1.34,0,0,0-1.07-.16,1.2,1.2,0,0,0-.8.75,2.1,2.1,0,0,0-.1,1,4.12,4.12,0,0,0,.12.59,2.66,2.66,0,0,0,.58,1.07,4.39,4.39,0,0,1-.2-.87,7.26,7.26,0,0,1,0-.8c0-.55.2-1.06.61-1.15s.83.13,1.14.59a8.44,8.44,0,0,1,.78,1.53A3.85,3.85,0,0,0,180.65,239.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.55,246.75S156.48,235.57,157,229c.23-3,4.22-5,4.22-5s12.91-12.95,27.09-3.44c1.68,1.13,5.83,4.75-1.07,8-6.72,3.21-20.63.45-20.63.45a48.42,48.42,0,0,1,.06,14.35A4.39,4.39,0,0,1,163.55,246.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.64,245.38s-5.27-5.47-7.82-3.49,2.1,10.38,5.57,11.08a3.37,3.37,0,0,0,4.18-2.5Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.21,244.26a0,0,0,0,0,0,.09c2.44.57,4,2.51,5.19,4.59a1.87,1.87,0,0,0-2.84-.07c-.05,0,0,.14.09.11a2.08,2.08,0,0,1,2.37.36,10.29,10.29,0,0,1,1.36,1.65c.14.19.5,0,.38-.2l0,0C166.33,247.8,163.4,244.06,160.21,244.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.71,217.94c-2.14.24-13,4.55-17.2,8.46s-10.37,14.2-10.68,14.74-9.14-16.77,4.36-25.4C178.9,206.33,187.71,217.94,187.71,217.94Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4,240.09s5.08-16.34,9.42-21.22,15.84-10.91,24.5-10.33c6.76.46-4.75,13.11-4.75,13.11a4.31,4.31,0,0,0-3.3-2c-4.16-.13-10.67,3.49-14.13,6.24C167.78,229.36,160.4,240.09,160.4,240.09Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.4,240.09s5.08-16.34,9.42-21.22,15.84-10.91,24.5-10.33c6.76.46-4.75,13.11-4.75,13.11a4.31,4.31,0,0,0-3.3-2c-4.16-.13-10.67,3.49-14.13,6.24C167.78,229.36,160.4,240.09,160.4,240.09Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M660.76,427.81c.23,3-8.4,3.88-12,1.93a85.68,85.68,0,0,1-8.31-6.83c-8.65-7.65-20.61-18.85-20.61-18.85l-8.86,4-43.3,14.41-18.26-47.24s21-8.86,40.87-16.8c3.06-1.22,6.08-2.4,9-3.54l.54-.22c13.37-5.14,24.44-9,25.58-8.23C628.49,348.56,660.54,424.77,660.76,427.81Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.77,427.8c.23,3-8.4,3.89-12,1.94a81.72,81.72,0,0,1-8.3-6.83c-8.66-7.64-20.62-18.85-20.62-18.85l-8.87,4-1.44.47-19.89-49.84c.22-.1.43-.18.64-.26,3.07-1.21,6.09-2.4,9-3.54l.54-.21c13.37-5.14,24.44-9,25.59-8.24C628.49,348.56,660.54,424.77,660.77,427.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.53,428.92c-.18-3.1-31.85-81.1-34.94-83.3-1.16-.86-12.79,3.1-26.71,8.27l-.44.17,19.87,50.55.84-.37s25.48,24.44,29.13,26.5S661.73,432,661.53,428.92Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.15,429.26c-5.66-13-27.26-66.05-31.87-79.35,0-.11,0-.14.09,0,5.89,12.78,27.06,66,32,79.29C658.47,429.45,658.27,429.54,658.15,429.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.72,410.15c-3.06-4.78-4.84-11.43-2.75-16.88.08-.21.37-.1.39.09a78.46,78.46,0,0,0,3,16.5A.36.36,0,0,1,621.72,410.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.49,413c-3.07-4.78-4.84-11.43-2.76-16.88.08-.21.38-.09.4.1a78.06,78.06,0,0,0,3,16.5A.36.36,0,0,1,625.49,413Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.26,415.79c-3.07-4.78-4.84-11.43-2.76-16.88.08-.21.38-.09.39.1a79.35,79.35,0,0,0,3,16.5A.35.35,0,0,1,629.26,415.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.6,416.15c1.36-4.82.59-10,.43-15a.68.68,0,0,0-1-.55.15.15,0,0,0-.24-.05,29.78,29.78,0,0,0-8.61,12.78c-.94,2.9-.66,7.19,3,8.09C616.6,422.31,618.8,419,619.6,416.15Zm-3.63,3c-5.31,3.21-4.8-4.09-4-6.2A30.7,30.7,0,0,1,613.8,409a89.48,89.48,0,0,1,4.86-7.58c-.07,2.42.07,4.82.08,7.24C618.76,411.57,618.9,417.38,616,419.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.93,386.52c-2.72,2.56-.85,6.44,1.39,8.5a29.72,29.72,0,0,0,13.78,6.9.14.14,0,0,0,.18-.15.69.69,0,0,0,.58-1c-2.28-4.36-4.18-9.3-7.73-12.82C610.06,385.93,606.5,384.1,603.93,386.52Zm11.12,8.39c1.18,2.12,2.24,4.28,3.49,6.35a87.73,87.73,0,0,1-8-4.21,31.35,31.35,0,0,1-3.55-2.53c-1.71-1.45-5.74-7.57.47-7.37C610.92,387.26,613.65,392.39,615.05,394.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.53,428.91c.2,3.1-8.61,3.88-12.25,1.83s-29.13-26.5-29.13-26.5l-.84.37L603.6,364.66l30.93-2.79C644.89,385.48,661.41,426.68,661.53,428.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.1,416.78S509,438.4,474.36,432.16c-16.57-3-28.53-24.31-20.56-40.64,7.43-15.24,52.86-30.71,65.69-39.67,4-2.81,3.61-14,3.61-14l33.72-.45s12,19.09,6.93,28.39a3.89,3.89,0,0,1-.29.46l15.21-5.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.26,391.33c-3.75-8.15-7.86-16.12-11.68-24.23-.07-.16-.33-.07-.26.09,3.61,8.18,6.93,16.47,10.68,24.59s7.82,16.14,11.75,24.21c.1.2.44.09.34-.13C589.46,407.69,586,399.46,582.26,391.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.68,366.69c-2.32,1.35-4.54,2.93-6.8,4.38s-4.47,2.86-6.74,4.22c-4.6,2.73-9.31,5.29-14.08,7.73a242.83,242.83,0,0,1-29.71,12.79c-5.67,2-11.41,3.94-17.25,5.39-.13,0-.07.23.06.19,4.25-1,8.5-2,12.71-3.2-2.23,1.4-4.42,2.87-6.64,4.29-.11.07,0,.25.11.18,2.42-1.47,4.88-2.87,7.29-4.37a.24.24,0,0,0,.06-.34c.72-.21,1.44-.41,2.16-.63,5.2-1.61,10.34-3.42,15.38-5.46A189,189,0,0,0,549,377.31c2.58-1.6,5.14-3.24,7.65-4.94a68.12,68.12,0,0,0,7.26-5.38C564.1,366.84,563.87,366.59,563.68,366.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.89,439.37c.23,3-8.4,3.88-12,1.93a81.72,81.72,0,0,1-8.3-6.83c-8.65-7.65-20.62-18.84-20.62-18.84l-8.86,4-42,14.37-19.55-47.2s21-8.86,40.87-16.8c3.06-1.22,6.08-2.4,9-3.54l.55-.21c13.36-5.15,24.44-9,25.57-8.24C664.61,360.12,696.66,436.33,696.89,439.37Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.88,439.37c.24,3-8.4,3.89-12,1.93a83.53,83.53,0,0,1-8.3-6.83c-8.65-7.65-20.63-18.85-20.63-18.85l-8.85,4-1.18.4-20.65-49.59,1.14-.44c3.06-1.23,6.08-2.41,9-3.55l.54-.22c13.38-5.14,24.44-9,25.58-8.22C664.61,360.12,696.65,436.32,696.88,439.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.67,440.05c-.23-3.1-33-80.65-36.08-82.81-1.18-.84-12.75,3.27-26.6,8.64l-.43.17,20.56,50.27L656,416S681.77,440,685.45,442,697.92,443.14,697.67,440.05Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.3,440.44c-5.84-12.94-28.17-65.67-33-78.9,0-.11,0-.14.08,0,6.07,12.7,28,65.61,33.09,78.85C694.62,440.63,694.42,440.71,694.3,440.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.61,421.83c-3.13-4.74-5-11.36-3-16.84.08-.21.38-.1.39.09a79.15,79.15,0,0,0,3.24,16.46A.36.36,0,0,1,657.61,421.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.42,424.6c-3.14-4.74-5-11.36-3-16.84.08-.21.38-.1.4.09a78.51,78.51,0,0,0,3.24,16.46A.36.36,0,0,1,661.42,424.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.22,427.37c-3.13-4.74-5-11.36-3-16.84.08-.21.38-.1.4.09a78.27,78.27,0,0,0,3.23,16.45A.36.36,0,0,1,665.22,427.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.57,427.86c1.29-4.83.45-10.06.23-15a.7.7,0,0,0-1-.53c0-.08-.14-.13-.23-.05a29.77,29.77,0,0,0-8.44,12.9c-.9,2.91-.56,7.2,3.07,8.05C652.65,434.06,654.81,430.68,655.57,427.86ZM652,430.92c-5.26,3.29-4.86-4-4.11-6.14a32.19,32.19,0,0,1,1.8-4,87,87,0,0,1,4.76-7.64c0,2.42.13,4.82.18,7.24C654.67,423.29,654.88,429.1,652,430.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.49,398.45c-2.68,2.6-.76,6.45,1.51,8.48a29.8,29.8,0,0,0,13.87,6.71.15.15,0,0,0,.18-.16.69.69,0,0,0,.57-1c-2.34-4.33-4.31-9.24-7.9-12.72C645.62,397.77,642,396,639.49,398.45Zm11.24,8.24c1.2,2.1,2.29,4.24,3.57,6.3-2.7-1.32-5.44-2.51-8-4.1a32.72,32.72,0,0,1-3.59-2.48c-1.73-1.43-5.84-7.49.37-7.38C646.49,399.09,649.3,404.19,650.73,406.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.7,337.68l58-.87s12.3,31.29,7.21,40.6S541.39,400,541.39,400l73.4-27.92,24.43,56.25S550,447.79,502.63,443c-17.76-1.81-28.91-25-18.51-42.85,10.95-18.76,50.68-44.42,50.68-44.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.88,371.94c-22.47,10.27-45.13,20.09-68.31,28.64q-4.83,1.79-9.68,3.53c-3.35,1.2-6.67,2.58-10.1,3.55-.17,0-.08.31.08.25,3-1.11,6-1.9,9-2.88s5.86-1.93,8.78-2.95l3.77-1.34c-.26.18-.51.36-.76.52-1.16.78-2.31,1.55-3.45,2.35-2.35,1.65-4.53,3.61-7,5.08-.15.09,0,.33.15.23,2.34-1.66,5-2.91,7.38-4.47,1.16-.77,2.3-1.56,3.44-2.37a22.51,22.51,0,0,0,3-2.33c3.7-1.32,7.38-2.66,11-4.06q17.33-6.6,34.21-14.23c6.29-2.85,12.52-5.81,18.68-8.94C613.48,372.36,613.22,371.79,612.88,371.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.68,402.4c-3.75-8.15-7.87-16.12-11.68-24.23-.08-.16-.33-.07-.26.09,3.61,8.18,6.93,16.47,10.68,24.59s7.82,16.14,11.75,24.21c.1.2.44.09.34-.13C626.88,418.76,623.42,410.53,619.68,402.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.75,356.3a158.4,158.4,0,0,0-18.31,12.16c-5.82,4.31-11.45,8.86-16.82,13.72-2.71,2.45-5.32,5-7.85,7.64a59.64,59.64,0,0,0-6.67,8.05,28.29,28.29,0,0,0-4.8,17.69,29.92,29.92,0,0,0,2.3,9.67,35.69,35.69,0,0,0,5.37,8.29c.08.1.23,0,.14-.15a22.71,22.71,0,0,1-4.53-7.93,29.86,29.86,0,0,1,2.26-25.52c3.56-5.91,8.79-10.81,13.77-15.51a208.79,208.79,0,0,1,16.12-13.72c3.14-2.42,6.34-4.77,9.56-7.08s6.52-4.53,9.68-6.95A.21.21,0,0,0,533.75,356.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.6,358.64c-4.72-1.65-9.87-2.29-14.81-2.84s-9.89-.81-14.86-.88c-.14,0-.12.19,0,.2,5,.45,10.07,1.08,15.06,1.83s9.68,1.77,14.56,2.16C550.84,359.14,550.84,358.72,550.6,358.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590,359.33a71.31,71.31,0,0,1-9.23-.84c-2.54-.36-5.14-.74-7.24-2.32-4.11-3.09-5.79-8.51-6.66-13.35,0-.11-.22-.08-.2,0,.7,5.27.94,11.32,5.56,14.86a14,14,0,0,0,7.88,2.46,49,49,0,0,0,9.9-.62A.11.11,0,0,0,590,359.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.4,367.67a61.86,61.86,0,0,0-1.63-9c-.72-3.06-1.59-6.08-2.56-9.07-1.1-3.39-2.38-6.73-3.71-10,0-.13-.24-.07-.2.05,1.92,5.6,3.66,11.27,5.12,17,.72,2.84,1.36,5.7,1.94,8.58a17.89,17.89,0,0,1,0,8.42,14.76,14.76,0,0,1-4.64,7.22,0,0,0,1,0,0,0A15.13,15.13,0,0,0,596.4,367.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.32,384.87c-3.91,1-7.75,2.37-11.59,3.62s-7.7,2.49-11.54,3.77c-7.68,2.56-15.34,5.21-23,7.86-4.35,1.5-8.66,3.1-13,4.68-.12,0-.07.24.06.2q23.19-7.2,46.11-15.29c4.33-1.52,8.73-2.93,13-4.7A.07.07,0,0,0,606.32,384.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.57,263.48c.42,17.75-3.34,55.72-10.06,68.75-2.9,5.61-25.13,22.19-38.08,29.24-4.83,2.63-22.36-24.53-17.43-28,3.36-2.33,28.46-19.35,30.43-21.9,3.63-4.68,17-39.58,24.49-54.05C542.12,249.49,548.31,252.44,548.57,263.48Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.42,357.73c-.41.44-6.17,6.75-10.1,9.71-2.92,2.21-11.52,8.35-14.27,5.36-1.88-2,2.75-6.23,6-9.27,1.69-1.61,3.36-4.65,2.27-5.72-1.89-1.86-6.2,2.38-8.85,5.65-5.12,6.33-11.26,19.56-16.55,17.75-2-.68-1.11-6.65.61-9.89-3.18,4.23-6.83,11.08-9.08,10.41-1.29-.38-1.73-4.4-1.63-5.81a3.12,3.12,0,0,1-3.42.73c-1.91-.9-2.05-3.26-1.38-6a1.76,1.76,0,0,1-1.55-.34c-4.55-3.3,5.06-21.42,9.6-24.5,13.34-9.09,29.06-14.34,29.06-14.34C493.61,333.9,505.42,357.71,505.42,357.73Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.68,352.45a26.65,26.65,0,0,0-8.35,7.5c-2.79,3.88-4.16,7.69-6.18,11.78,0,.1.12.19.17.08,1-1.94,5.15-9.46,6.3-11.25a25.35,25.35,0,0,1,8.1-8.06S478.72,352.43,478.68,352.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.57,347.26a63.83,63.83,0,0,0-9.89,8.29c-3.15,3.5-5,7.92-6.8,12.2-1.09,2.57-2.13,5.17-3.1,7.79,0,.11.12.2.16.08q2.74-6.6,5.87-13a33.53,33.53,0,0,1,7.89-10.51c1.89-1.69,3.9-3.22,5.91-4.75A0,0,0,0,0,473.57,347.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.37,343.39c-3.45,2.2-6.47,4.1-9,7.38-3.38,4.33-5.92,10.43-6.8,12.59-1,2.38-1.87,4.79-2.72,7.21,0,.1.13.17.17.07A134.87,134.87,0,0,1,456.11,355a26.7,26.7,0,0,1,4.81-6.59,47.15,47.15,0,0,1,6.47-4.95S467.39,343.38,467.37,343.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.61,282.84l24.48,14.79s1.91-31.4-.13-40.79c-2.3-10.57-7.21-7.08-12.84,1.52S524.61,282.84,524.61,282.84Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.61,282.84l24.48,14.79s1.91-31.4-.13-40.79c-2.3-10.57-7.21-7.08-12.84,1.52S524.61,282.84,524.61,282.84Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.14,278.93c3.38,1.46,12.87,7.27,14.45,8.21.84.5,4.07,2.63,4.9,3.12.11.06,0,.22-.11.16-1.59-.94-3.29-1.71-4.89-2.63s-11.48-6.49-14.42-8.73C528,279,528.07,278.9,528.14,278.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597,348.58l-77.71,2.59c.06,1.52,2.32-61,21.28-98.37,1.29-2.55,13.41-5.65,19-.86C583.79,272.9,597,349.57,597,348.58Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.29,345.3l-76.82,2.56c0-.29,0-.61,0-.95l76.59-2.53C596.17,344.7,596.23,345,596.29,345.3ZM595,338.84l-75,2.5c0,.32-.06.64-.09.94l75.28-2.5C595.09,339.47,595,339.16,595,338.84Zm-1.22-5.53-73.29,2.43c0,.32-.05.64-.07.95L594,334.25Zm-1.29-5.51L521,330.17c0,.32-.06.62-.1.93l71.73-2.38C592.6,328.41,592.53,328.11,592.45,327.8Zm-1.35-5.53-69.39,2.3c0,.32-.08.64-.13.95l69.75-2.31C591.25,322.9,591.17,322.59,591.1,322.27Zm-1.45-5.51L522.45,319c-.05.32-.09.63-.13.95l67.59-2.25C589.82,317.37,589.74,317.06,589.65,316.76Zm-1.52-5.53-64.85,2.16c-.06.32-.1.63-.15.94l65.27-2.17Q588.26,311.71,588.13,311.23Zm-1.62-5.51-62.32,2.07c-.06.32-.11.64-.17.94l62.78-2.08C586.71,306.34,586.6,306,586.51,305.72Zm-1.71-5.51-59.6,2c-.06.32-.13.64-.18.95l60.07-2C585,300.83,584.9,300.52,584.8,300.21ZM583,294.7l-56.66,1.88c-.06.32-.12.63-.19.95l57.17-1.9C583.19,295.31,583.07,295,583,294.7Zm-2-5.5L527.54,291c-.07.32-.15.63-.21.94l54-1.79C581.24,289.81,581.13,289.5,581,289.2Zm-2.11-5.49-50,1.65c-.08.31-.17.63-.24.95l50.59-1.68C579.13,284.32,579,284,578.89,283.71Zm-2.3-5.49-46.19,1.52c-.09.31-.18.63-.26.95L577,279.14C576.85,278.83,576.71,278.53,576.59,278.22ZM574,272.73l-42,1.39c-.1.32-.2.63-.29.95l42.69-1.42C574.33,273.34,574.18,273,574,272.73Zm-2.87-5.48-37.23,1.24c-.12.31-.22.63-.34.95l38.07-1.27C571.49,267.87,571.33,267.56,571.16,267.25Zm-3.33-5.45L536,262.85c-.13.31-.25.63-.38.95l32.77-1.09C568.23,262.4,568,262.1,567.83,261.8Zm-4-5.44-25.38.85c-.16.31-.3.63-.44,1l26.57-.89ZM558.11,251l-16.13.53a4.47,4.47,0,0,0-1.27,1l18.7-.61A7,7,0,0,0,558.11,251Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.52,262.93c3.79.34,10.8-5.09,12.65-10.7.12-.39-1.09-4-2.36-8.41-.76-2.69-1.55-5.7-2.06-8.5-.11-.58-16.79,7.51-16.79,7.51a45.33,45.33,0,0,1,3.68,10.44,6,6,0,0,1,.09,1.17c0,.06,0,.12,0,.2C538.79,256.89,539.46,262.57,543.52,262.93Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.73,254.44c0,.06,0,.13,0,.2a12.72,12.72,0,0,0,1.81-.24c10.3-2.14,10.65-15.58,10.57-19-3,1-16.17,7.38-16.17,7.38a45.82,45.82,0,0,1,3.69,10.45A6.84,6.84,0,0,1,538.73,254.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.29,214.33c2.88,6,2.38,24.56-1.45,29.29-5.54,6.85-16,9-22.2,2.06-6-6.78-4.9-31-.49-35.44C532.63,203.7,546,205.52,550.29,214.33Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.33,227.9c0-.05.09.06.09.11-.07,1.25.07,2.7,1.19,3.14a0,0,0,0,1,0,.07C534.22,231,534.06,229.07,534.33,227.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.47,226.61c2-.11,2.09,3.94.22,4S533.78,226.7,535.47,226.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.08,228.22s-.1.06-.1.12c.06,1.25-.08,2.69-1.21,3.13a0,0,0,0,0,0,.07C527.17,231.32,527.33,229.4,527.08,228.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.93,226.93c-2-.11-2.1,3.93-.23,4S527.63,227,525.93,226.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,224.73a14.59,14.59,0,0,1-1.58-.52,2.68,2.68,0,0,1-1.5-.84.85.85,0,0,1,.12-1,2.11,2.11,0,0,1,2.13-.26,3.12,3.12,0,0,1,1.82,1.32A.91.91,0,0,1,537,224.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.33,224.92a15.36,15.36,0,0,0,1.61-.44,2.75,2.75,0,0,0,1.54-.76.86.86,0,0,0-.07-1.05,2.13,2.13,0,0,0-2.11-.36,3.15,3.15,0,0,0-1.89,1.22A.91.91,0,0,0,524.33,224.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.68,239.51c-.29.29-.59.7-1,.75a3.52,3.52,0,0,1-1.35-.29,0,0,0,0,0,0,.06,1.68,1.68,0,0,0,1.6.66,1.33,1.33,0,0,0,1-1.13C535.82,239.49,535.73,239.46,535.68,239.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.3,235.78a4.22,4.22,0,0,1-2.81,1.94,5.29,5.29,0,0,1-1.54.1,1.36,1.36,0,0,1-.29,0l-.28,0a.3.3,0,0,1-.25-.27h0a.57.57,0,0,1,0-.13h0v-.11c0-1,0-2.43,0-2.43-.35.18-2.13,1-2.11.51a65.08,65.08,0,0,1,1.43-12.94.12.12,0,0,1,.23,0c0,4-.73,8-.8,12.05a7.71,7.71,0,0,1,2-.64c.14,0-.18,2.83-.13,3.27a.16.16,0,0,0,0,0,5.92,5.92,0,0,0,4.39-1.44C534.27,235.59,534.38,235.68,534.3,235.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.51,237.32a5.12,5.12,0,0,0,2.06,1.54,2.31,2.31,0,0,0,1.38.06c1-.28,1-1.2.81-2a5.37,5.37,0,0,0-.47-1.2A6.53,6.53,0,0,1,530.51,237.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.57,238.86a2.31,2.31,0,0,0,1.38.06c1-.28,1-1.2.81-2A2.34,2.34,0,0,0,532.57,238.86Z",
    style: {
      fill: "#ff98b9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,230.12c.3-1.72,2.8-20.21,2.12-22.13-.62-1.75-2.5-.81-2.54-.91s-.27-1.73-1.34-2.24a2.76,2.76,0,0,0-2.18.27s-.49-1.7-1.62-2.05a2.19,2.19,0,0,0-2.07.67,2.88,2.88,0,0,0-1.93-1.88,1.89,1.89,0,0,0-2,1s-.63-1.6-1.79-1.8-2,1.11-2,1.11a2.47,2.47,0,0,0-2.14-1.31c-1.4.12-1.75,1.67-1.75,1.67a3,3,0,0,0-2.26-1.27c-1.29.09-1.57,1.75-1.57,1.75s-.67-1.38-1.88-1.17-1.31,1.95-1.31,1.95-.84-1.51-2.22-.9c-2.12.93-1.33,11.42-1.37,16,0,0,.39-2.24,1.31-2.41s1.77,1.23,3.54,1.44c2.52.29,6.34-3,9.81-2.64s6.18,3.6,7.9,8.67C547.62,229.69,552.29,234.21,553,230.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.45,234.8a5.27,5.27,0,0,1-4.5-5.94h0a5.28,5.28,0,1,1,4.5,5.94Zm-3.8-5.85a4.57,4.57,0,1,0,5.15-3.9,4.84,4.84,0,0,0-1.14,0A4.57,4.57,0,0,0,531.65,229Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.32,234.71c-2.16,0-3.91-2.38-3.9-5.29a6.37,6.37,0,0,1,1.13-3.68,3.28,3.28,0,0,1,5.62,0,6.22,6.22,0,0,1,1.1,3.69c0,2.75-1.6,5-3.6,5.24A2,2,0,0,1,524.32,234.71Zm-2.2-8.55a5.6,5.6,0,0,0-1,3.27c0,2.52,1.42,4.57,3.19,4.58s3.23-2,3.25-4.55a5.63,5.63,0,0,0-1-3.28,2.77,2.77,0,0,0-2.23-1.3h-.27A2.92,2.92,0,0,0,522.12,226.16Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.13,229.47l.45-.54c-.8-.67-2.64-1.59-3.93-.21l.51.48C529.32,228,531.05,229.41,531.13,229.47Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.61,230.94l.63-.32c-.16-.3-1.51-2.87-3.08-3.13s-10.93.59-11.33.63l.07.7c2.71-.24,10-.83,11.14-.64S554.24,230.23,554.61,230.94Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548,230s3.32-6.41,6.17-5.31.92,10-2,11.61a3.21,3.21,0,0,1-4.49-1.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.58,227.21s.07.06,0,.09c-2.07,1.18-3,3.36-3.47,5.58a1.77,1.77,0,0,1,2.56-.83c.06,0,0,.13-.05.12a2,2,0,0,0-2.06,1,9.71,9.71,0,0,0-.79,1.88c-.08.21-.45.16-.4-.08v-.05C549,232.1,550.62,227.9,553.58,227.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.88,278.61c-4.44,19.5-15.25,49.74-24.82,52-13.74,3.22-45.14-16.59-54.52-23.42-3.54-2.57,15.82-28.17,19.95-26,5.66,3,21.15,15.23,24.66,15.26,2.51,0,13.06-17,23.46-30.38C564.53,246.85,564.19,264.05,560.88,278.61Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,311.23c-11.5-5.53-26.16-11.71-34.18-23.66a7.16,7.16,0,0,1-1.3-4.49c-3.69-5.29-2.3-8.62-2.3-8.62-1.93-6,0-9.2,0-9.2s-4.26-6.26-.9-9.47c3.75-3.61,9,5.89,15.09,9.35,13.94,7.93,36,15.29,40.23,17.18Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.13,283.72a104,104,0,0,1-11.82-7.63,103.77,103.77,0,0,1-11-10.82.12.12,0,1,0-.19.16c5.3,7.85,14.16,14.79,22.87,18.47C472.23,284,472.33,283.84,472.13,283.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.57,292.83c-3.82-2.57-10.5-7.13-19.25-18.47,0,0-.1,0-.08.05A49,49,0,0,0,468.45,293C468.7,293.15,468.82,293,468.57,292.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.56,297.69c-6.32-4.61-9.72-8.32-15-14.6a0,0,0,0,0-.07.05c5.27,7.76,8.06,10,15,14.79C466.67,298.09,466.81,297.87,466.56,297.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.11,281.46s15.77-12.67,17.78-14.15c2.55-1.87,31.14-11.38,31.36-13.11.36-2.82-29.55-6.63-35.12-6.89-4.24-.2-28.69,6-28.69,6Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref24), /*#__PURE__*/React.createElement("path", {
    d: "M466.48,280.37s15.76-12.67,17.78-14.15c2.54-1.87,31.77-10.29,32-12,.36-2.82-30.19-7.71-35.76-8-4.24-.2-28.69,6-28.69,6Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.18,264.61a3.48,3.48,0,0,1,.34.51,13,13,0,0,0-2.26,1.1c-.69.51-3,2.33-5.73,4.5a4,4,0,0,1-1.21-1c-1.49-1.86-.7-4.5,1.75-5.91S484.7,262.76,486.18,264.61Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.06,268.19c2.44-1.41,3.23-4.06,1.75-5.92s-4.67-2.23-7.12-.83-3.23,4.06-1.75,5.92S463.61,269.59,466.06,268.19Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.92,247.14h0a4.16,4.16,0,0,1,1.73,1.26c1.49,1.86.7,4.52-1.74,5.91s-5.64,1-7.12-.82a3.65,3.65,0,0,1,.53-5C469.63,248,471.9,247.53,473.92,247.14Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.88,255.82c2.45-1.41,3.23-4.06,1.75-5.92s-4.67-2.23-7.11-.83-3.24,4.06-1.76,5.92S490.43,257.22,492.88,255.82Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.22,256.18c.1.12.18.25.27.38-2.66,1-6.17,2.2-9.78,3.4-.42-1.64.47-3.5,2.39-4.61C506.55,254,509.74,254.32,511.22,256.18Z",
    style: {
      fill: "#bc5648"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.5,266.88c3.08,6.74,6.61,11.49,9.46,13.74,3.14,2.48,5.5,2.15,7.27,1,1.62-1,2.4-2.8.89-5.3-2-3.27-5.3-8-7.29-12.2-2.1-4.46-3.21-9.1-4.56-12.37-1.28-3.12-2.74-4.8-5.55-4.27s-4.46,2.11-4.35,5.39C450.49,256.66,452.53,262.58,454.5,266.88Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.5,266.88c3.08,6.74,6.61,11.49,9.46,13.74,3.14,2.48,5.5,2.15,7.27,1,1.62-1,2.4-2.8.89-5.3-2-3.27-5.3-8-7.29-12.2-2.1-4.46-3.21-9.1-4.56-12.37-1.28-3.12-2.74-4.8-5.55-4.27s-4.46,2.11-4.35,5.39C450.49,256.66,452.53,262.58,454.5,266.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34), /*#__PURE__*/React.createElement("path", {
    d: "M480.76,273.63c2.22.31,2.4-.86-.36-3.74S464.24,258,467.79,253.55s22.27,8.65,26.5,13.8,9.29,15,9.29,15C499.43,280.5,488.94,277.07,480.76,273.63Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.91,285.73l22.7,20.45s8.34-32.56,8.09-42.83c-.28-11.55-6.13-8.88-13.77-1S533.91,285.73,533.91,285.73Z",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.91,285.73l22.7,20.45s8.34-32.56,8.09-42.83c-.28-11.55-6.13-8.88-13.77-1S533.91,285.73,533.91,285.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.4,282.34c3.25,2.21,12,10.22,13.51,11.53.77.69,3.74,3.58,4.51,4.26.1.09,0,.23-.15.14-1.48-1.3-3.1-2.45-4.6-3.75s-10.73-9.11-13.37-12.06C538.25,282.39,538.33,282.29,538.4,282.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.58,294.43a9.24,9.24,0,0,1,2.39.82c.37.19.74.38,1.1.59a11.38,11.38,0,0,0,1.08.64,2.51,2.51,0,0,1-1.31-.1,7.24,7.24,0,0,1-3.26-1.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.31,320.12c3.25,1.28,6.37,2.75,9.5,4.21l4.68,2.21c1.56.72,3.11,1.48,4.72,2.13a26.35,26.35,0,0,1-5-1.41c-1.64-.6-3.23-1.29-4.81-2A66.89,66.89,0,0,1,502.31,320.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pizza-box--inject-40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 336.25,
    y: 423.7,
    width: 105.46,
    height: 13.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.88,
    y: 423.7,
    width: 69.37,
    height: 13.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.88,
    y: 423.7,
    width: 69.37,
    height: 13.47,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.94 430.91 230.96 342.87 239.9 335.65 266.88 423.69 257.94 430.91",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.94 430.91 230.96 342.87 239.9 335.65 266.88 423.69 257.94 430.91",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.77 423.69 266.88 423.69 239.9 335.65 345.8 335.79 372.77 423.69",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.77 423.69 266.88 423.69 239.9 335.65 345.8 335.79 372.77 423.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.35 423.69 337.28 345.39 345.84 335.65 372.82 423.69 361.35 423.69",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.35 423.69 337.28 345.39 345.84 335.65 372.82 423.69 361.35 423.69",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.28 345.39 345.84 335.65 239.9 335.65 242.98 345.69 337.28 345.39",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.05,430.51a1.07,1.07,0,0,1-.09.43,1.15,1.15,0,0,1-.22.35,1.16,1.16,0,0,1-.34.24,1.07,1.07,0,0,1-.41.08,1.06,1.06,0,0,1-.4-.08,1,1,0,0,1-.34-.24,1,1,0,0,1-.23-.35,1.26,1.26,0,0,1-.08-.43,1.16,1.16,0,0,1,.08-.42,1,1,0,0,1,.23-.36.89.89,0,0,1,.34-.23.9.9,0,0,1,.4-.09.91.91,0,0,1,.41.09,1,1,0,0,1,.34.23,1.09,1.09,0,0,1,.22.36A1,1,0,0,1,276.05,430.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.81,434.19v-7.47h3a2,2,0,0,1,.91.21,2.52,2.52,0,0,1,.72.57,2.71,2.71,0,0,1,.48.8,2.59,2.59,0,0,1,0,1.82,2.65,2.65,0,0,1-.46.8,2.22,2.22,0,0,1-.7.55,2,2,0,0,1-.91.21h-1.7v2.51Zm1.39-3.78h1.62a.8.8,0,0,0,.64-.32,1.43,1.43,0,0,0,.26-.89,1.6,1.6,0,0,0-.08-.51,1.27,1.27,0,0,0-.22-.38.76.76,0,0,0-.3-.24.94.94,0,0,0-.36-.08H282.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,434.19v-7.47h1.4v7.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,433.09l4.05-5.1h-3.94v-1.27h5.55v1.09l-3.92,5.1h3.95v1.28H296Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.57,433.09l4.06-5.1h-3.94v-1.27h5.54v1.09l-3.92,5.1h3.95v1.28h-5.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.63,426.72h1.23l2.72,7.47h-1.43l-.67-1.86H317l-.66,1.86h-1.43Zm1.6,4.59-1-2.94-1,2.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.75,430.51a1.07,1.07,0,0,1-.09.43,1.18,1.18,0,0,1-.23.35,1,1,0,0,1-.33.24,1.15,1.15,0,0,1-.41.08,1.11,1.11,0,0,1-.41-.08,1.16,1.16,0,0,1-.34-.24,1.15,1.15,0,0,1-.22-.35,1.06,1.06,0,0,1-.08-.43,1,1,0,0,1,.08-.42,1.09,1.09,0,0,1,.22-.36,1,1,0,0,1,.34-.23,1,1,0,0,1,.41-.09,1,1,0,0,1,.41.09.86.86,0,0,1,.33.23,1.11,1.11,0,0,1,.23.36A1,1,0,0,1,327.75,430.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Drinks--inject-40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.89,
    y: 382.38,
    width: 39.84,
    height: 1.99,
    transform: "translate(-256.1 343.66) rotate(-62.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.93 366.18 165.33 367.32 163.12 367.26 163.72 366.11 165.92 366.18 165.93 366.18",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.45 369.01 163.85 370.15 161.64 370.09 162.24 368.95 164.45 369.01",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.96 371.85 162.36 372.99 160.15 372.93 160.75 371.79 162.96 371.85",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.48 374.68 160.88 375.83 158.67 375.77 159.27 374.62 161.48 374.68",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.99 377.52 159.39 378.67 157.18 378.61 157.78 377.46 159.99 377.52",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.51 380.36 157.91 381.5 155.7 381.44 156.3 380.3 158.51 380.36",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.02 383.2 156.42 384.34 154.21 384.28 154.81 383.14 157.02 383.2",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.54 386.03 154.94 387.18 152.73 387.12 153.33 385.97 155.54 386.03",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.05 388.87 153.46 390.01 151.25 389.95 151.84 388.81 154.05 388.87",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.57 391.71 151.97 392.85 149.76 392.79 150.36 391.65 152.57 391.71",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.09 394.54 150.49 395.69 148.28 395.63 148.88 394.48 151.09 394.54",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.6 397.38 149 398.52 146.79 398.46 147.39 397.32 149.6 397.38",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.12 400.22 147.52 401.36 147.22 401.36 145.69 400.56 145.9 400.16 148.12 400.22",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.18 392.3 158.14 430.43 137.17 430.43 134.13 392.3 161.18 392.3",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.15,
    y: 388.86,
    width: 30.83,
    height: 5.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.87 388.86 134.26 388.86 135.82 385.09 159.31 385.09 160.87 388.86",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.43 426.87 158.15 430.43 137.16 430.43 136.88 426.87 158.43 426.87",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.56,412.57,159.3,416c-.36-.32-.71-.65-1-1a24.45,24.45,0,0,0-5.89-4.82,7.64,7.64,0,0,0-3.4-.92c-.27,0-.54,0-.8,0l-.74.13c-.23,0-.52.15-.76.21a3.54,3.54,0,0,0-.74.23c-.56.18-1.1.38-1.65.61-.23.09-.46.18-.69.29l-.54.23c-1,.48-2,1.06-3.2,1.65a16.56,16.56,0,0,1-3.86,1.48l-.11,0-.25-3.16c.65-.53,1.3-1.11,2-1.71.32-.27.65-.55,1-.81s.69-.53,1.07-.78a11.41,11.41,0,0,1,1.22-.76,9.4,9.4,0,0,1,4.3-1.33,6.31,6.31,0,0,1,1.15,0,6.62,6.62,0,0,1,1.15.16l1.16.31c.36.12.7.3,1,.45a24.64,24.64,0,0,1,3.51,2.25A36.93,36.93,0,0,0,159.56,412.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,416l-.18,2.23a11.91,11.91,0,0,1-4-.21l-1-.24-1-.36a15.12,15.12,0,0,1-1.82-.86,25.49,25.49,0,0,1-3.21-2.24c-1.52-1.2-3-2.48-4.54-3.56a17.21,17.21,0,0,0-1.57-1,13,13,0,0,0-1.67-.83c-.29-.12-.59-.18-.88-.27a4,4,0,0,0-.83-.21h0a7.48,7.48,0,0,0-3.16.06l-.13-1.69a5.19,5.19,0,0,1,.56,0,5.93,5.93,0,0,1,1,.05l1,.17c.34.08.66.21,1,.31s.55.22.81.34a18.78,18.78,0,0,1,2.67,1.51c.64.42,1.27.85,1.9,1.28,1.49,1,3,2,4.49,2.91a20.44,20.44,0,0,0,6.72,2.73,11.08,11.08,0,0,0,1.72.14,14.52,14.52,0,0,0,1.73-.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.67,
    y: 397.11,
    width: 39.84,
    height: 1.99,
    transform: "translate(-99.79 631.35) rotate(-62.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "481.71 380.91 481.11 382.05 478.9 381.99 479.5 380.84 481.7 380.91 481.71 380.91",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.23 383.75 479.63 384.89 477.42 384.82 478.02 383.68 480.23 383.75",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.74 386.58 478.14 387.73 475.93 387.66 476.53 386.52 478.74 386.58",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "477.26 389.42 476.66 390.56 474.45 390.5 475.05 389.35 477.26 389.42",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.77 392.25 475.17 393.4 472.96 393.34 473.56 392.19 475.77 392.25",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.29 395.09 473.69 396.24 471.48 396.17 472.08 395.03 474.29 395.09",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "472.8 397.93 472.2 399.07 469.99 399.01 470.59 397.87 472.8 397.93",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.32 400.76 470.72 401.91 468.51 401.85 469.11 400.7 471.32 400.76",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.83 403.6 469.24 404.74 467.03 404.68 467.62 403.54 469.83 403.6",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.35 406.44 467.75 407.58 465.54 407.52 466.14 406.38 468.35 406.44",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.87 409.27 466.27 410.42 464.06 410.36 464.66 409.21 466.87 409.27",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.38 412.11 464.78 413.25 462.57 413.19 463.17 412.05 465.38 412.11",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.9 414.95 463.3 416.09 463 416.09 461.48 415.29 461.69 414.89 463.9 414.95",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.96 407.04 473.92 445.16 452.95 445.16 449.92 407.04 476.96 407.04",
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.93,
    y: 403.59,
    width: 30.83,
    height: 5.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.65 403.59 450.04 403.59 451.6 399.83 475.09 399.83 476.65 403.59",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "474.21 441.6 473.93 445.17 452.94 445.17 452.66 441.6 474.21 441.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.35,427.3l-.27,3.45c-.36-.32-.71-.65-1-1a24.69,24.69,0,0,0-5.89-4.82,7.6,7.6,0,0,0-3.4-.92c-.27,0-.54,0-.8,0l-.74.13c-.23,0-.52.15-.76.21a3.54,3.54,0,0,0-.74.23c-.56.18-1.1.38-1.65.61-.23.09-.46.18-.69.29l-.54.24c-1,.47-2,1.05-3.2,1.64a16.56,16.56,0,0,1-3.86,1.48l-.11,0-.25-3.15c.65-.54,1.3-1.12,2-1.72.32-.27.65-.55,1-.81s.69-.53,1.07-.78a13.28,13.28,0,0,1,1.22-.76,9.52,9.52,0,0,1,4.3-1.33,6.3,6.3,0,0,1,1.15,0,9.34,9.34,0,0,1,1.15.16l1.16.31c.36.12.7.3,1,.45a24.64,24.64,0,0,1,3.51,2.25A36,36,0,0,0,475.35,427.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.08,430.75,474.9,433a11.91,11.91,0,0,1-4-.21l-1-.24-1-.36a15.12,15.12,0,0,1-1.82-.86,25.49,25.49,0,0,1-3.21-2.24c-1.52-1.2-3-2.48-4.54-3.56-.51-.35-1-.69-1.57-1a11.74,11.74,0,0,0-1.67-.82,7.46,7.46,0,0,0-.88-.28,4,4,0,0,0-.83-.21h-.05a7.64,7.64,0,0,0-3.16.06l-.13-1.68a3.46,3.46,0,0,1,.56,0,5.94,5.94,0,0,1,1,.06l1,.16c.34.08.66.21,1,.31s.55.22.81.34a19.8,19.8,0,0,1,2.67,1.51c.64.42,1.27.85,1.9,1.28,1.49,1,3,2,4.49,2.92a20.42,20.42,0,0,0,6.72,2.72A11.08,11.08,0,0,0,473,431a16.34,16.34,0,0,0,1.73-.18Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.dc9216ec.svg";
export { ForwardRef as ReactComponent };